const base64js = require('base64-js');
import Validator from 'validatorjs';

/* @ngInject */
export default class RentalsCaptureCtrl {
    constructor($scope, $rootScope, $timeout, RentalsCaptureService, NotificationService, LocalStorageService, CountriesUtilService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.LocalStorageService = LocalStorageService;
        this.NotificationService = NotificationService;
        this.RentalsCaptureService = RentalsCaptureService;
        this.CountriesUtilService = CountriesUtilService;

        this.init();
        this._registerEventHandler();
        this.activate();
        this.loadSignaturePads();
    }

    init() {
        this.isBusy = false;
        this.isCityLivingUnit = false;
        this.loadingSpinner = null;
        this.howToGuideLink;
        this.attachment = {};
        this.documentType = '0';
        this.selectedAttachment = {};
        this.showOtherMaritalStatus = false;
        this.hasClearanceHeaderBeenSaved = false;
        this.secondApplicationChosen = false;
        this.thirdApplicationChosen = false;
        this.fourthApplicationChosen = false;
        this.isFirstApplicantPartner = false;
        this.isSecondApplicantPartner = false;
        this.isThirdApplicantPartner = false;
        this.signaturedata = null;
        this.RentalInitialApplicationsIDFetched = null;
        this.formsErrors = {
            acknowledgmentSection: [],
            firstApplicant: [],
            secondApplicant: [],
            thirdApplicant: [],
            fourthApplicant: [],
            generalSection: [],
            declarationSection: []
        };

        const today = new Date();
        let year = today.getFullYear();

        this.documentTypeListLoaded = [{}];
        this.headerDocumentsAlreadyUpLoaded = [{}];

        var urlToken = window.location.search;
        const myArray = urlToken.split("=");
        var rentalsApplicationToken = myArray[1];
        var rentalInitialApplicationsData = this.$timeout(async () => {
            try {
                this.RentalInitialApplicationsIDFetched = await this.RentalsCaptureService.getRentalInitialApplication(rentalsApplicationToken);
            }
            catch (e) {
                console.log("failed to get data");
            }
            finally {
                this.setRentalInitialData();
            }
        });

        this.rentalsHeader = {
            Id: 'ABD6F6D3-12DD-4261-90F5-45B568A7E53A',
            WhoIsApplying: "",
            premisesAddress: "",
            rentalAmount: null,
            leasePeriod: 12,
            RentalInitialApplicationsID: "",
            OccupationDate: null
        };

        this.firstPerson = {
            fullName: "",
            ApplicantNumber: 1,
            ID_Passport: "",
            Nationality: "",
            DateOfBirth: "",
            email: "",
            Telephone_Home: null,
            Telephone_Cell: null,
            MaritalStatus: null,
            nextOfKinName: "",
            nextOfKinTelephone: null,
            CurrentStreet: "",
            CurrentSuburb: "",
            CurrentCity: "",
            CurrentProvince: "",
            CurrentPostalCode: "",
            ID_Attachment: null,
            ProofOfAddressAttachment: null,
            OwnCurrentResidence: null,
            landlordName: "",
            LandlordNumber: null,
            landlordEmail: "",
            RentalAmountPaid: null,
            TimeLivingAtResidence: null,
            employersName: "",
            Occupation: "",
            EmployersEmail: "",
            EmployersNumber: null,
            PeriodOfEmployment: null,
            grossMonthlySalary: null,
            currentMonthlyExpenses: null,
            employersStreet: "",
            employersSuburb: "",
            employersCity: "",
            employersProvince: "",
            employersPostalcode: "",
            payslips: null,
            bankStatements: null,
            RentalInitialApplicationsID: "",
            applicantSignataure: null
        };

        this.secondPerson = {
            fullName: "",
            ApplicantNumber: 2,
            ID_Passport: "",
            Nationality: "",
            DateOfBirth: "",
            email: "",
            Telephone_Home: null,
            Telephone_Cell: null,
            MaritalStatus: null,
            nextOfKinName: "",
            nextOfKinTelephone: null,
            CurrentStreet: "",
            CurrentSuburb: "",
            CurrentCity: "",
            CurrentProvince: "",
            CurrentPostalCode: "",
            ID_Attachment: null,
            ProofOfAddressAttachment: null,
            OwnCurrentResidence: null,
            landlordName: "",
            LandlordNumber: null,
            landlordEmail: "",
            RentalAmountPaid: null,
            TimeLivingAtResidence: null,
            employersName: "",
            Occupation: "",
            EmployersEmail: "",
            EmployersNumber: null,
            PeriodOfEmployment: null,
            grossMonthlySalary: null,
            currentMonthlyExpenses: null,
            employersStreet: "",
            employersSuburb: "",
            employersCity: "",
            employersProvince: "",
            employersPostalcode: "",
            payslips: null,
            bankStatements: null,
            RentalInitialApplicationsID: ""
        };

        this.thirdPerson = {
            fullName: "",
            ApplicantNumber: 3,
            ID_Passport: "",
            Nationality: "",
            DateOfBirth: "",
            email: "",
            Telephone_Home: null,
            Telephone_Cell: null,
            MaritalStatus: null,
            nextOfKinName: "",
            nextOfKinTelephone: null,
            CurrentStreet: "",
            CurrentSuburb: "",
            CurrentCity: "",
            CurrentProvince: "",
            CurrentPostalCode: "",
            ID_Attachment: null,
            ProofOfAddressAttachment: null,
            OwnCurrentResidence: null,
            landlordName: "",
            LandlordNumber: null,
            landlordEmail: "",
            RentalAmountPaid: null,
            TimeLivingAtResidence: null,
            employersName: "",
            Occupation: "",
            EmployersEmail: "",
            EmployersNumber: null,
            PeriodOfEmployment: null,
            grossMonthlySalary: null,
            currentMonthlyExpenses: null,
            employersStreet: "",
            employersSuburb: "",
            employersCity: "",
            employersProvince: "",
            employersPostalcode: "",
            payslips: null,
            bankStatements: null,
            RentalInitialApplicationsID: ""
        };

        this.fourthPerson = {
            fullName: "",
            ApplicantNumber: 4,
            ID_Passport: "",
            Nationality: "",
            DateOfBirth: "",
            email: "",
            Telephone_Home: null,
            Telephone_Cell: null,
            MaritalStatus: null,
            nextOfKinName: "",
            nextOfKinTelephone: null,
            CurrentStreet: "",
            CurrentSuburb: "",
            CurrentCity: "",
            CurrentProvince: "",
            CurrentPostalCode: "",
            ID_Attachment: null,
            ProofOfAddressAttachment: null,
            OwnCurrentResidence: null,
            landlordName: "",
            LandlordNumber: null,
            landlordEmail: "",
            RentalAmountPaid: null,
            TimeLivingAtResidence: null,
            employersName: "",
            Occupation: "",
            EmployersEmail: "",
            EmployersNumber: null,
            PeriodOfEmployment: null,
            grossMonthlySalary: null,
            currentMonthlyExpenses: null,
            employersStreet: "",
            employersSuburb: "",
            employersCity: "",
            employersProvince: "",
            employersPostalcode: "",
            payslips: null,
            bankStatements: null,
            RentalInitialApplicationsID: ""
        };

        this.generalDetails = {
            RentalInitialApplicationsID: "",
            ApplicantOccupyingBuilding: null,
            numberOfAdults: null,
            numberOfChildren: 0,
            childAge1: null,
            childAge2: null,
            childAge3: null,
            childAge4: null,
            numberOfPets: null,
            petType: "",
            numberOfVehicles: 0,
            VehicleType1: "",
            Vehicle1Registration: "",
            VehicleType2: "",
            Vehicle2Registration: "",
            VehicleType3: "",
            Vehicle3Registration: "",
            VehicleType4: "",
            Vehicle4Registration: "",
            PreviousDefaults: false,
            defaultDetails: "",
            SeenProperty: false,
            SupportingDocument1: null,
            SupportingDocument2: null,
            SupportingDocument3: null,
            OtherTenantFullName: null,
            OtherTenantCellNumber: null,
            OtherTenantEmail: null
        };

        this.declarations = {
            RentalInitialApplicationsID: "",
            WhereSigned: "",
            DaySigned: null,
            MonthSigned: null,
            YearSigned: year,
            FirstApplicantCorrID: "",
            SecondApplicantCorrID: "",
            ThirdApplicantCorrID: "",
            FourthApplicantCorrID: ""
        };

        var firstIDBlobData = {};
        var firstProofOfAddressBlobData = {};
        var firstPayslipBlobData = {};
        var firstBankStatementsBlobData = {};

        var secondIDBlobData = {};
        var secondProofOfAddressBlobData = {};
        var secondPayslipBlobData = {};
        var secondBankStatementsBlobData = {};

        var thirdIDBlobData = {};
        var thirdProofOfAddressBlobData = {};
        var thirdPayslipBlobData = {};
        var thirdBankStatementsBlobData = {};

        var fourthIDBlobData = {};
        var fourthProofOfAddressBlobData = {};
        var fourthPayslipBlobData = {};
        var fourthBankStatementsBlobData = {};

        var firstPersonSignature = {};
        var secondPersonSignature = {};
        var thirdPersonSignature = {};
        var fourthPersonSignature = {};

        var supportingDoc1 = {};
        var supportingDoc2 = {};
        var supportingDoc3 = {};

        this.livesWithPartner2 = false;
        this.spousIsWorking2 = true;

        this.livesWithPartner3 = false;
        this.spousIsWorking3 = true;

        this.livesWithPartner4 = false;
        this.spousIsWorking4 = true;

        var uploadedSignatureBlobData = {};
        var uploadedSignatureBlobData2 = {};
        var uploadedSignatureBlobData3 = {};
        var uploadedSignatureBlobData4 = {};

        $("#upload").hide();
        $("#upload2").hide();
        $("#upload3").hide();
        $("#upload4").hide();

        $("#sigpad").hide();
        $("#sigpad2").hide();
        $("#sigpad3").hide();
        $("#sigpad4").hide();

        $("#clear").hide();
        $("#edit").hide();
        $("#signature-pad-empty").hide();

        $("#clear2").hide();
        $("#edit2").hide();
        $("#signature-pad-empty2").hide();

        $("#clear3").hide();
        $("#edit3").hide();
        $("#signature-pad-empty3").hide();

        $("#clear4").hide();
        $("#edit4").hide();
        $("#signature-pad-empty4").hide();

        this.removeFourthApplicantClick();
        this.removeThirdApplicantClick()
        this.removeSecondApplicantClick();
        this.getNumberOfChildren();
        this.getNumberOfVehincles();

        this.monthsArr = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        this.countries = [
            "South Africa",
            "Afghanistan",
            "Aland Islands",
            "Albania",
            "Algeria",
            "American Samoa",
            "Andorra",
            "Angola",
            "Anguilla",
            "Antarctica",
            "Antigua and Barbuda",
            "Argentina",
            "Armenia",
            "Aruba",
            "Australia",
            "Austria",
            "Azerbaijan",
            "Bahamas",
            "Bahrain",
            "Bangladesh",
            "Barbados",
            "Belarus",
            "Belgium",
            "Belize",
            "Benin",
            "Bermuda",
            "Bhutan",
            "Bolivia",
            "Bosnia and Herzegovina",
            "Botswana",
            "Bouvet Island",
            "Brazil",
            "British Indian Ocean Territory",
            "Brunei Darussalam",
            "Bulgaria",
            "Burkina Faso",
            "Burundi",
            "Cambodia",
            "Cameroon",
            "Canada",
            "Cape Verde",
            "Cayman Islands",
            "Central African Republic",
            "Chad",
            "Chile",
            "China",
            "Christmas Island",
            "Cocos (Keeling) Islands",
            "Colombia",
            "Comoros",
            "Congo",
            "Congo, The Democratic Republic of The",
            "Cook Islands",
            "Costa Rica",
            "Cote D'ivoire",
            "Croatia",
            "Cuba",
            "Curacao",
            "Cyprus",
            "Czech Republic",
            "Denmark",
            "Djibouti",
            "Dominica",
            "Dominican Republic",
            "Ecuador",
            "Egypt",
            "El Salvador",
            "Equatorial Guinea",
            "Eritrea",
            "Estonia",
            "Ethiopia",
            "Falkland Islands (Malvinas)",
            "Faroe Islands",
            "Fiji",
            "Finland",
            "France",
            "French Guiana",
            "French Polynesia",
            "French Southern Territories",
            "Gabon",
            "Gambia",
            "Georgia",
            "Germany",
            "Ghana",
            "Gibraltar",
            "Greece",
            "Greenland",
            "Grenada",
            "Guadeloupe",
            "Guam",
            "Guatemala",
            "Guernsey",
            "Guinea",
            "Guinea-bissau",
            "Guyana",
            "Haiti",
            "Heard Island and Mcdonald Islands",
            "Holy See (Vatican City State)",
            "Honduras",
            "Hong Kong",
            "Hungary",
            "Iceland",
            "India",
            "Indonesia",
            "Iran, Islamic Republic of",
            "Iraq",
            "Ireland",
            "Isle of Man",
            "Israel",
            "Italy",
            "Jamaica",
            "Japan",
            "Jersey",
            "Jordan",
            "Kazakhstan",
            "Kenya",
            "Kiribati",
            "Korea, Democratic People's Republic of",
            "Korea, Republic of",
            "Kuwait",
            "Kyrgyzstan",
            "Lao People's Democratic Republic",
            "Latvia",
            "Lebanon",
            "Lesotho",
            "Liberia",
            "Libyan Arab Jamahiriya",
            "Liechtenstein",
            "Lithuania",
            "Luxembourg",
            "Macao",
            "Macedonia, The Former Yugoslav Republic of",
            "Madagascar",
            "Malawi",
            "Malaysia",
            "Maldives",
            "Mali",
            "Malta",
            "Marshall Islands",
            "Martinique",
            "Mauritania",
            "Mauritius",
            "Mayotte",
            "Mexico",
            "Micronesia, Federated States of",
            "Moldova, Republic of",
            "Monaco",
            "Mongolia",
            "Montenegro",
            "Montserrat",
            "Morocco",
            "Mozambique",
            "Myanmar",
            "Namibia",
            "Nauru",
            "Nepal",
            "Netherlands",
            "New Caledonia",
            "New Zealand",
            "Nicaragua",
            "Niger",
            "Nigeria",
            "Niue",
            "Norfolk Island",
            "Northern Mariana Islands",
            "Norway",
            "Oman",
            "Pakistan",
            "Palau",
            "Palestinian Territory, Occupied",
            "Panama",
            "Papua New Guinea",
            "Paraguay",
            "Peru",
            "Philippines",
            "Pitcairn",
            "Poland",
            "Portugal",
            "Puerto Rico",
            "Qatar",
            "Reunion",
            "Romania",
            "Russia",
            "Rwanda",
            "Saint Helena",
            "Saint Kitts and Nevis",
            "Saint Lucia",
            "Saint Pierre and Miquelon",
            "Saint Vincent and The Grenadines",
            "Samoa",
            "San Marino",
            "Sao Tome and Principe",
            "Saudi Arabia",
            "Senegal",
            "Serbia",
            "Seychelles",
            "Sierra Leone",
            "Singapore",
            "Slovakia",
            "Slovenia",
            "Solomon Islands",
            "Somalia",
            "South Georgia and The South Sandwich Islands",
            "Spain",
            "Sri Lanka",
            "Sudan",
            "Suriname",
            "Svalbard and Jan Mayen",
            "Eswatini",
            "Sweden",
            "Switzerland",
            "Syrian Arab Republic",
            "Taiwan (ROC)",
            "Tajikistan",
            "Tanzania, United Republic of",
            "Thailand",
            "Timor-leste",
            "Togo",
            "Tokelau",
            "Tonga",
            "Trinidad and Tobago",
            "Tunisia",
            "Turkey",
            "Turkmenistan",
            "Turks and Caicos Islands",
            "Tuvalu",
            "Uganda",
            "Ukraine",
            "United Arab Emirates",
            "United Kingdom",
            "United States",
            "United States Minor Outlying Islands",
            "Uruguay",
            "Uzbekistan",
            "Vanuatu",
            "Venezuela",
            "Vietnam",
            "Virgin Islands, British",
            "Virgin Islands, U.S.",
            "Wallis and Futuna",
            "Western Sahara",
            "Yemen",
            "Zambia",
            "Zimbabwe"
        ]
    }

    populateDropdown() {
        var dropdown = document.getElementById("dropdown");
        var selectedOptionElement = document.getElementById("selectedOption");

        dropdown.innerHTML = "";

        console.log(this.monthsArr);
        this.monthsArr.forEach(function (option) {
            var optionElement = document.createElement("option");
            optionElement.textContent = option;
            optionElement.value = option;

            dropdown.appendChild(optionElement);
        });

        dropdown.addEventListener("change", function () {

        })
    }

    _registerEventHandler() {
        this.$scope.$watch('rentalsCaptureVm.firstPerson.MaritalStatus', (newVal, oldVal) => {
            if (newVal == 5) {
                this.addSecondApplicantClick();
                this.isFirstApplicantPartner = true;
                $("#secondApplicantHeading")[0].innerText = "DETAILS OF THE SPOUSE OF THE FIRST APPLICANT TO RENT THE PROPERTY";
                $("#removeSecondApplicantDiv").hide();
            }
            else if (oldVal == 5) {
                this.removeSecondApplicantClick();
                this.isFirstApplicantPartner = false;
                $("#secondApplicantHeading")[0].innerText = "DETAILS OF THE SECOND PERSON APPLYING TO RENT THE PROPERTY";
            }
        });

        this.$scope.$watch('rentalsCaptureVm.secondPerson.MaritalStatus', (newVal, oldVal) => {
            if (newVal == 5) {
                this.addThirdApplicantClick();
                this.isSecondApplicantPartner = true;
                $("#thirdApplicantHeading")[0].innerText = "DETAILS OF THE SPOUSE OF THE SECOND APPLICANT TO RENT THE PROPERTY";
                $("#removeThirdApplicantDiv").hide();
            }
            else if (oldVal == 5) {
                this.removeThirdApplicantClick();
                this.isSecondApplicantPartner = false;
                $("#thirdApplicantHeading")[0].innerText = "DETAILS OF THE THIRD PERSON APPLYING TO RENT THE PROPERTY";
            }
            
        });

        this.$scope.$watch('rentalsCaptureVm.fourthPerson.MaritalStatus', (newVal, oldVal) => {
            if (newVal == 5) {
                this.addFourthApplicantClick();
                this.isThirdApplicantPartner = true;
                $("#fourthApplicantHeading")[0].innerText = "DETAILS OF THE SPOUSE OF THE THIRD APPLICANT TO RENT THE PROPERTY";
                $("#removeFourthApplicantDiv").hide();
            }
            else if (oldVal == 5) {
                this.removeThirdApplicantClick();
                this.isThirdApplicantPartner = false;
                $("#fourthApplicantHeading")[0].innerText = "DETAILS OF THE FOURTH PERSON APPLYING TO RENT THE PROPERTY";
            }
        });
    }


    activate() {
        //this.howToGuideLink = `${PretorCDNAddress}${PretorCDNAddress.endsWith('/')
        //    ? ''
        //    : '/'}docs/Clearance How-To-Guide.pdf`;
        this.getMaritalStatuses();
        //this._initializeDatePicker();
    }

    loadSignaturePads() {
        $(document).ready(function () {
            var SignaturePad = (function (document) {
                "use strict";

                var log = console.log.bind(console);

                var SignaturePad = function (canvas, options) {
                    var self = this,
                        opts = options || {};

                    this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
                    this.minWidth = opts.minWidth || 0.5;
                    this.maxWidth = opts.maxWidth || 2.5;
                    this.dotSize = opts.dotSize || function () {
                        return (self.minWidth + self.maxWidth) / 2;
                    };
                    this.penColor = opts.penColor || "black";
                    this.backgroundColor = opts.backgroundColor || "rgba(0,0,0,0)";
                    this.throttle = opts.throttle || 0;
                    this.throttleOptions = {
                        leading: true,
                        trailing: true
                    };
                    this.minPointDistance = opts.minPointDistance || 0;
                    this.onEnd = opts.onEnd;
                    this.onBegin = opts.onBegin;

                    this._canvas = canvas;

                    this._ctx = canvas.getContext("2d");
                    this._ctx.lineCap = 'round';
                    this.clear();

                    // we need add these inline so they are available to unbind while still having
                    //  access to 'self' we could use _.bind but it's not worth adding a dependency
                    this._handleMouseDown = function (event) {
                        if (event.which === 1) {
                            self._mouseButtonDown = true;
                            self._strokeBegin(event);
                        }
                    };

                    var _handleMouseMove = function (event) {
                        event.preventDefault();
                        if (self._mouseButtonDown) {
                            self._strokeUpdate(event);
                            if (self.arePointsDisplayed) {
                                var point = self._createPoint(event);
                                self._drawMark(point.x, point.y, 5);
                            }
                        }
                    };

                    this._handleMouseMove = _.throttle(_handleMouseMove, self.throttle, self.throttleOptions);
                    this._handleMouseUp = function (event) {
                        if (event.which === 1 && self._mouseButtonDown) {
                            self._mouseButtonDown = false;
                            self._strokeEnd(event);
                        }
                    };

                    this._handleTouchStart = function (event) {
                        if (event.targetTouches.length == 1) {
                            var touch = event.changedTouches[0];
                            self._strokeBegin(touch);
                        }
                    };

                    var _handleTouchMove = function (event) {
                        // Prevent scrolling.
                        event.preventDefault();

                        var touch = event.targetTouches[0];
                        self._strokeUpdate(touch);
                        if (self.arePointsDisplayed) {
                            var point = self._createPoint(touch);
                            self._drawMark(point.x, point.y, 5);
                        }
                    };
                    this._handleTouchMove = _.throttle(_handleTouchMove, self.throttle, self.throttleOptions);
                    //this._handleTouchMove = _handleTouchMove;

                    this._handleTouchEnd = function (event) {
                        var wasCanvasTouched = event.target === self._canvas;
                        if (wasCanvasTouched) {
                            event.preventDefault();
                            self._strokeEnd(event);
                        }
                    };

                    this._handleMouseEvents();
                    this._handleTouchEvents();
                };

                SignaturePad.prototype.clear = function () {
                    var ctx = this._ctx,
                        canvas = this._canvas;
                    ctx.fillStyle = this.backgroundColor;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    this._reset();
                    RentalsCaptureCtrl.firstPersonSignature = {
                        FileName: null,
                        Blob: null
                    }
                };

                SignaturePad.prototype.showPointsToggle = function () {
                    this.arePointsDisplayed = !this.arePointsDisplayed;
                };

                SignaturePad.prototype.toDataURL = function (imageType, quality) {
                    var canvas = this._canvas;
                    return canvas.toDataURL.apply(canvas, arguments);
                };

                SignaturePad.prototype.getBlobData = function (dataURL) {
                    var arr = dataURL.split(','), mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }

                    return new Blob([u8arr], { type: mime });
                };

                SignaturePad.prototype.getByteArrayData = function (dataURL) {
                    var arr = dataURL.split(','), mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }

                    const byteArray = [];
                    Object.keys(u8arr).forEach((key) => {
                        const byteForKey = u8arr[key];
                        byteArray.push(byteForKey);
                    });

                    return byteArray;
                };

                SignaturePad.prototype.fromDataURL = function (dataUrl) {
                    var self = this,
                        image = new Image(),
                        ratio = window.devicePixelRatio || 1,
                        width = this._canvas.width / ratio,
                        height = this._canvas.height / ratio;

                    this._reset();
                    image.src = dataUrl;
                    image.onload = function () {
                        self._ctx.drawImage(image, 0, 0, width, height);
                    };
                    this._isEmpty = false;
                };

                SignaturePad.prototype._strokeUpdate = function (event) {
                    var point = this._createPoint(event);
                    if (this._isPointToBeUsed(point)) {
                        this._addPoint(point);
                    }
                };

                SignaturePad.prototype._isPointToBeUsed = function (point) {
                    if (!this.minPointDistance)
                        return true;

                    var points = this.points;
                    if (points && points.length) {
                        var lastPoint = points[points.length - 1];
                        if (point.distanceTo(lastPoint) < this.minPointDistance) {
                            return false;
                        }
                    }
                    return true;
                };

                SignaturePad.prototype._strokeBegin = function (event) {
                    this._reset();
                    this._strokeUpdate(event);
                    if (typeof this.onBegin === 'function') {
                        this.onBegin(event);
                    }
                };

                SignaturePad.prototype._strokeDraw = function (point) {
                    var ctx = this._ctx,
                        dotSize = typeof (this.dotSize) === 'function' ? this.dotSize() : this.dotSize;

                    ctx.beginPath();
                    this._drawPoint(point.x, point.y, dotSize);
                    ctx.closePath();
                    ctx.fill();
                };

                SignaturePad.prototype._strokeEnd = function (event) {
                    var canDrawCurve = this.points.length > 2,
                        point = this.points[0];

                    if (!canDrawCurve && point) {
                        this._strokeDraw(point);
                    }
                    if (typeof this.onEnd === 'function') {
                        this.onEnd(event);
                    }
                };

                SignaturePad.prototype._handleMouseEvents = function () {
                    this._mouseButtonDown = false;

                    this._canvas.addEventListener("mousedown", this._handleMouseDown);
                    this._canvas.addEventListener("mousemove", this._handleMouseMove);
                    document.addEventListener("mouseup", this._handleMouseUp);
                };

                SignaturePad.prototype._handleTouchEvents = function () {
                    // Pass touch events to canvas element on mobile IE11 and Edge.
                    this._canvas.style.msTouchAction = 'none';
                    this._canvas.style.touchAction = 'none';

                    this._canvas.addEventListener("touchstart", this._handleTouchStart);
                    this._canvas.addEventListener("touchmove", this._handleTouchMove);
                    this._canvas.addEventListener("touchend", this._handleTouchEnd);
                };

                SignaturePad.prototype.on = function () {
                    this._handleMouseEvents();
                    this._handleTouchEvents();
                };

                SignaturePad.prototype.off = function () {
                    this._canvas.removeEventListener("mousedown", this._handleMouseDown);
                    this._canvas.removeEventListener("mousemove", this._handleMouseMove);
                    document.removeEventListener("mouseup", this._handleMouseUp);

                    this._canvas.removeEventListener("touchstart", this._handleTouchStart);
                    this._canvas.removeEventListener("touchmove", this._handleTouchMove);
                    this._canvas.removeEventListener("touchend", this._handleTouchEnd);
                };

                SignaturePad.prototype.isEmpty = function () {
                    return this._isEmpty;
                };

                SignaturePad.prototype._reset = function () {
                    this.points = [];
                    this._lastVelocity = 0;
                    this._lastWidth = (this.minWidth + this.maxWidth) / 2;
                    this._isEmpty = true;
                    this._ctx.fillStyle = this.penColor;
                };

                SignaturePad.prototype._createPoint = function (event) {
                    var rect = this._canvas.getBoundingClientRect();
                    return new Point(
                        event.clientX - rect.left,
                        event.clientY - rect.top
                    );
                };

                SignaturePad.prototype._addPoint = function (point) {
                    var points = this.points,
                        c2, c3,
                        curve, tmp;

                    points.push(point);

                    if (points.length > 2) {
                        // To reduce the initial lag make it work with 3 points
                        // by copying the first point to the beginning.
                        if (points.length === 3) points.unshift(points[0]);

                        tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
                        c2 = tmp.c2;
                        tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
                        c3 = tmp.c1;
                        curve = new Bezier(points[1], c2, c3, points[2]);
                        this._addCurve(curve);

                        // Remove the first element from the list,
                        // so that we always have no more than 4 points in points array.
                        points.shift();
                    }
                };

                SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
                    var dx1 = s1.x - s2.x,
                        dy1 = s1.y - s2.y,
                        dx2 = s2.x - s3.x,
                        dy2 = s2.y - s3.y,

                        m1 = {
                            x: (s1.x + s2.x) / 2.0,
                            y: (s1.y + s2.y) / 2.0
                        },
                        m2 = {
                            x: (s2.x + s3.x) / 2.0,
                            y: (s2.y + s3.y) / 2.0
                        },

                        l1 = Math.sqrt(1.0 * dx1 * dx1 + dy1 * dy1),
                        l2 = Math.sqrt(1.0 * dx2 * dx2 + dy2 * dy2),

                        dxm = (m1.x - m2.x),
                        dym = (m1.y - m2.y),

                        k = l2 / (l1 + l2),
                        cm = {
                            x: m2.x + dxm * k,
                            y: m2.y + dym * k
                        },

                        tx = s2.x - cm.x,
                        ty = s2.y - cm.y;

                    return {
                        c1: new Point(m1.x + tx, m1.y + ty),
                        c2: new Point(m2.x + tx, m2.y + ty)
                    };
                };

                SignaturePad.prototype._addCurve = function (curve) {
                    var startPoint = curve.startPoint,
                        endPoint = curve.endPoint,
                        velocity, newWidth;

                    velocity = endPoint.velocityFrom(startPoint);
                    velocity = this.velocityFilterWeight * velocity +
                        (1 - this.velocityFilterWeight) * this._lastVelocity;

                    newWidth = this._strokeWidth(velocity);
                    this._drawCurve(curve, this._lastWidth, newWidth);

                    this._lastVelocity = velocity;
                    this._lastWidth = newWidth;
                };

                SignaturePad.prototype._drawPoint = function (x, y, size) {
                    var ctx = this._ctx;

                    ctx.moveTo(x, y);
                    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
                    this._isEmpty = false;
                };

                SignaturePad.prototype._drawMark = function (x, y, size) {
                    var ctx = this._ctx;

                    ctx.save();
                    ctx.moveTo(x, y);
                    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
                    ctx.fillStyle = 'rgba(255, 0, 0, 0.2)';
                    ctx.fill();
                    ctx.restore();
                };

                SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
                    var ctx = this._ctx,
                        widthDelta = endWidth - startWidth,
                        drawSteps, width, i, t, tt, ttt, u, uu, uuu, x, y;

                    drawSteps = Math.floor(curve.length());
                    ctx.beginPath();
                    for (i = 0; i < drawSteps; i++) {
                        // Calculate the Bezier (x, y) coordinate for this step.
                        t = i / drawSteps;
                        tt = t * t;
                        ttt = tt * t;
                        u = 1 - t;
                        uu = u * u;
                        uuu = uu * u;

                        x = uuu * curve.startPoint.x;
                        x += 3 * uu * t * curve.control1.x;
                        x += 3 * u * tt * curve.control2.x;
                        x += ttt * curve.endPoint.x;

                        y = uuu * curve.startPoint.y;
                        y += 3 * uu * t * curve.control1.y;
                        y += 3 * u * tt * curve.control2.y;
                        y += ttt * curve.endPoint.y;

                        width = startWidth + ttt * widthDelta;
                        this._drawPoint(x, y, width);
                    }
                    ctx.closePath();
                    ctx.fill();
                };

                SignaturePad.prototype._strokeWidth = function (velocity) {
                    return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
                };

                var Point = function (x, y, time) {
                    this.x = x;
                    this.y = y;
                    this.time = time || new Date().getTime();
                };

                Point.prototype.velocityFrom = function (start) {
                    return (this.time !== start.time) ? this.distanceTo(start) / (this.time - start.time) : 1;
                };

                Point.prototype.distanceTo = function (start) {
                    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
                };

                var Bezier = function (startPoint, control1, control2, endPoint) {
                    this.startPoint = startPoint;
                    this.control1 = control1;
                    this.control2 = control2;
                    this.endPoint = endPoint;
                };

                // Returns approximated length.
                Bezier.prototype.length = function () {
                    var steps = 10,
                        length = 0,
                        i, t, cx, cy, px, py, xdiff, ydiff;

                    for (i = 0; i <= steps; i++) {
                        t = i / steps;
                        cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
                        cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
                        if (i > 0) {
                            xdiff = cx - px;
                            ydiff = cy - py;
                            length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                        }
                        px = cx;
                        py = cy;
                    }
                    return length;
                };

                Bezier.prototype._point = function (t, start, c1, c2, end) {
                    return start * (1.0 - t) * (1.0 - t) * (1.0 - t) +
                        3.0 * c1 * (1.0 - t) * (1.0 - t) * t +
                        3.0 * c2 * (1.0 - t) * t * t +
                        end * t * t * t;
                };

                return SignaturePad;
            })(document);

            var signaturePad = new SignaturePad(document.getElementById('signature-pad'), {
                backgroundColor: 'rgba(255, 255, 255, 0)',
                penColor: 'rgb(0, 0, 0)',
                velocityFilterWeight: .7,
                minWidth: 0.5,
                maxWidth: 2.5,
                throttle: 16, // max x milli seconds on event update, OBS! this introduces lag for event update
                minPointDistance: 3,
            });

            var saveButton = document.getElementById('save'),
                clearButton = document.getElementById('clear'),
                editButton = document.getElementById('edit'),
                showPointsToggle = document.getElementById('showPointsToggle');

            saveButton.addEventListener('click', function (event) {
                var data = signaturePad.toDataURL('image/png');
                RentalsCaptureCtrl.firstPersonSignature = {
                    FileName: "Signature",
                    Blob: signaturePad.getByteArrayData(data)
                };

                $("#save").hide();
                $("#signature-pad").hide();
                $("#signature-pad-empty").show();
                $("#clear").show();
                $("#edit").show();

                const ctx = document.getElementById("signature-pad-empty").getContext("2d");
                ctx.font = "20px Italic Montserrat";
                ctx.fillStyle = "Grey";
                ctx.fillText("Signature Saved", 20, 55);
            });

            if (clearButton) {
                clearButton.addEventListener('click', function (event) {
                    signaturePad.clear();
                    RentalsCaptureCtrl.firstPersonSignature = {
                        FileName: null,
                        IntArray: null
                    };

                    $("#save").show();
                    $("#clear").hide();
                    $("#edit").hide();
                    $("#signature-pad").show();
                    $("#signature-pad-empty").hide();
                });
            }

            if (editButton) {
                editButton.addEventListener('click', function (event) {
                    $("#save").show();
                    $("#edit").hide();
                    $("#clear").hide();
                    $("#signature-pad").show();
                    $("#signature-pad-empty").hide();
                });
            }

            if (showPointsToggle) {
                showPointsToggle.addEventListener('click', function (event) {
                    signaturePad.showPointsToggle();
                    showPointsToggle.classList.toggle('toggle');
                });
            }

            var idAttachment1 = document.getElementById('ID_Attachment'),
                addressDoc1 = document.getElementById('ProofOfAddressAttachment'),
                payslip1 = document.getElementById('payslips'),
                bankStatement1 = document.getElementById('bankStatements'),
                idAttachment2 = document.getElementById('ID_Attachment2'),
                addressDoc2 = document.getElementById('ProofOfAddressAttachment2'),
                payslip2 = document.getElementById('payslips2'),
                bankStatement2 = document.getElementById('bankStatements2'),
                idAttachment3 = document.getElementById('ID_Attachment3'),
                addressDoc3 = document.getElementById('ProofOfAddressAttachment3'),
                payslip3 = document.getElementById('payslips3'),
                bankStatement3 = document.getElementById('bankStatements3'),
                idAttachment4 = document.getElementById('ID_Attachment4'),
                addressDoc4 = document.getElementById('ProofOfAddressAttachment4'),
                payslip4 = document.getElementById('payslips4'),
                bankStatement4 = document.getElementById('bankStatements4'),
                supportingDocument1 = document.getElementById('supportingDocument1'),
                supportingDocument2 = document.getElementById('supportingDocument2'),
                supportingDocument3 = document.getElementById('supportingDocument3');

            if (idAttachment1 != null) {
                idAttachment1.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#ID_Attachment')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.firstIDBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }
                        }
                    }
                    else {
                        document.getElementById('ID_Attachment').value = null;
                        RentalsCaptureCtrl.firstIDBlobData = {}
                    }

                });

                addressDoc1.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#ProofOfAddressAttachment')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.firstProofOfAddressBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('ProofOfAddressAttachment').value = null;
                        RentalsCaptureCtrl.firstProofOfAddressBlobData = {}
                    }
                });

                payslip1.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#payslips')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.firstPayslipBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('payslips').value = null;
                        RentalsCaptureCtrl.firstPayslipBlobData = {}
                    }
                });

                bankStatement1.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#bankStatements')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.firstBankStatementsBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }

                            }
                        }
                        else {
                            document.getElementById('bankStatements').value = null;
                            RentalsCaptureCtrl.firstBankStatementsBlobData = {}
                        }
                    }
                });

                idAttachment2.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#ID_Attachment2')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.secondIDBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('ID_Attachment2').value = null;
                        RentalsCaptureCtrl.secondIDBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                addressDoc2.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#ProofOfAddressAttachment2')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.secondProofOfAddressBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('ProofOfAddressAttachment2').value = null;
                        RentalsCaptureCtrl.secondProofOfAddressBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                payslip2.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#payslips2')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.secondPayslipBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('payslips2').value = null;
                        RentalsCaptureCtrl.secondPayslipBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                bankStatement2.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#bankStatements2')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.secondBankStatementsBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('bankStatements2').value = null;
                        RentalsCaptureCtrl.secondBankStatementsBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                idAttachment3.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#ID_Attachment3')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.thirdIDBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('ID_Attachment3').value = null;
                        RentalsCaptureCtrl.thirdIDBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                addressDoc3.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#ProofOfAddressAttachment3')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.thirdProofOfAddressBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('ProofOfAddressAttachment3').value = null;
                        RentalsCaptureCtrl.thirdProofOfAddressBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                payslip3.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#payslips3')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.thirdPayslipBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('payslips3').value = null;
                        RentalsCaptureCtrl.thirdPayslipBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                bankStatement3.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#bankStatements3')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.thirdBankStatementsBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('bankStatements3').value = null;
                        RentalsCaptureCtrl.thirdBankStatementsBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                idAttachment4.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#ID_Attachment4')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.fourthIDBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('ID_Attachment4').value = null;
                        RentalsCaptureCtrl.fourthIDBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                addressDoc4.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#ProofOfAddressAttachment4')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.fourthProofOfAddressBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('ProofOfAddressAttachment4').value = null;
                        RentalsCaptureCtrl.fourthProofOfAddressBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                payslip4.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#payslips4')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.fourthPayslipBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('payslips4').value = null;
                        RentalsCaptureCtrl.fourthPayslipBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                bankStatement4.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#bankStatements4')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.fourthBankStatementsBlobData = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('bankStatements4').value = null;
                        RentalsCaptureCtrl.fourthBankStatementsBlobData = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                supportingDocument1.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#supportingDocument1')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.supportingDoc1 = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('supportingDocument1').value = null;
                        RentalsCaptureCtrl.supportingDoc1 = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                supportingDocument2.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#supportingDocument2')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.supportingDoc2 = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('supportingDocument2').value = null;
                        RentalsCaptureCtrl.supportingDoc2 = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });

                supportingDocument3.addEventListener('change', function (event) {
                    const file2 = $('input[type=file]#supportingDocument3')[0].files[0];
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {
                        let reader = new FileReader();
                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                RentalsCaptureCtrl.supportingDoc3 = {
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                            }

                        }
                    }
                    else {
                        document.getElementById('supportingDocument3').value = null;
                        RentalsCaptureCtrl.supportingDoc3 = {
                            FileName: null,
                            Blob: null
                        }
                    }
                });
            }
            var check_file_pdf = function (file) {
                if (file.type !== 'application/pdf') {
                    const errorMsg = 'Wrong file type, only PDFs are allowed.';

                    console.error(
                        `${errorMsg} "${file.name}" is not in the correct format - only PDFs are allowed.`
                    );

                    document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format - only PDFs are allowed. Please contact RicardoP@pretor.co.za for assistance.`;
                    $("#attachmentFailureModal").modal('show');
                    return false;
                }
                else if (file.name.length > 50) {
                    const errorMsg = 'Filename too long. Please shorten your filename to less than 50 characters.';

                    console.error(
                        `Filename too long. Please shorten your filename to less than 50 characters.`
                    );
                    document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format. Please contact RicardoP@pretor.co.za for assistance.`;
                    $("#attachmentFailureModal").modal('show');
                    return false;
                }
                else if (file.size > 100242880) {
                    const errorMsg = 'File size too large. Please reduce the size of your file to smaller than 100 mega bytes.';

                    console.error(
                        `File size too large. Please reduce the size of your file to smaller than 100 mega bytes.`
                    );
                    document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format. Please contact RicardoP@pretor.co.za for assistance.`;
                    $("#attachmentFailureModal").modal('show');
                    return false;
                }
                else {
                    return true;

                }
            }

            //section 3
            var SignaturePad2 = (function (document) {
                "use strict";

                var log = console.log.bind(console);

                var SignaturePad2 = function (canvas, options) {
                    var self = this,
                        opts = options || {};

                    this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
                    this.minWidth = opts.minWidth || 0.5;
                    this.maxWidth = opts.maxWidth || 2.5;
                    this.dotSize = opts.dotSize || function () {
                        return (self.minWidth + self.maxWidth) / 2;
                    };
                    this.penColor = opts.penColor || "black";
                    this.backgroundColor = opts.backgroundColor || "rgba(0,0,0,0)";
                    this.throttle = opts.throttle || 0;
                    this.throttleOptions = {
                        leading: true,
                        trailing: true
                    };
                    this.minPointDistance = opts.minPointDistance || 0;
                    this.onEnd = opts.onEnd;
                    this.onBegin = opts.onBegin;

                    this._canvas = canvas;

                    this._ctx = canvas.getContext("2d");
                    this._ctx.lineCap = 'round';
                    this.clear();

                    // we need add these inline so they are available to unbind while still having
                    //  access to 'self' we could use _.bind but it's not worth adding a dependency
                    this._handleMouseDown = function (event) {
                        if (event.which === 1) {
                            self._mouseButtonDown = true;
                            self._strokeBegin(event);
                        }
                    };

                    var _handleMouseMove = function (event) {
                        event.preventDefault();
                        if (self._mouseButtonDown) {
                            self._strokeUpdate(event);
                            if (self.arePointsDisplayed) {
                                var point = self._createPoint(event);
                                self._drawMark(point.x, point.y, 5);
                            }
                        }
                    };

                    this._handleMouseMove = _.throttle(_handleMouseMove, self.throttle, self.throttleOptions);
                    //this._handleMouseMove = _handleMouseMove;

                    this._handleMouseUp = function (event) {
                        if (event.which === 1 && self._mouseButtonDown) {
                            self._mouseButtonDown = false;
                            self._strokeEnd(event);
                        }
                    };

                    this._handleTouchStart = function (event) {
                        if (event.targetTouches.length == 1) {
                            var touch = event.changedTouches[0];
                            self._strokeBegin(touch);
                        }
                    };

                    var _handleTouchMove = function (event) {
                        // Prevent scrolling.
                        event.preventDefault();

                        var touch = event.targetTouches[0];
                        self._strokeUpdate(touch);
                        if (self.arePointsDisplayed) {
                            var point = self._createPoint(touch);
                            self._drawMark(point.x, point.y, 5);
                        }
                    };
                    this._handleTouchMove = _.throttle(_handleTouchMove, self.throttle, self.throttleOptions);
                    //this._handleTouchMove = _handleTouchMove;

                    this._handleTouchEnd = function (event) {
                        var wasCanvasTouched = event.target === self._canvas;
                        if (wasCanvasTouched) {
                            event.preventDefault();
                            self._strokeEnd(event);
                        }
                    };

                    this._handleMouseEvents();
                    this._handleTouchEvents();
                };

                SignaturePad2.prototype.clear = function () {
                    var ctx = this._ctx,
                        canvas = this._canvas;

                    ctx.fillStyle = this.backgroundColor;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    this._reset();
                    RentalsCaptureCtrl.secondPersonSignature = {
                        FileName: null,
                        Blob: null
                    }
                };

                SignaturePad2.prototype.showPointsToggle = function () {
                    this.arePointsDisplayed = !this.arePointsDisplayed;
                };

                SignaturePad2.prototype.toDataURL = function (imageType, quality) {
                    var canvas = this._canvas;
                    return canvas.toDataURL.apply(canvas, arguments);
                };

                SignaturePad2.prototype.getBlobData = function (dataURL) {
                    var arr = dataURL.split(','), mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }

                    return new Blob([u8arr], { type: mime });
                };

                SignaturePad2.prototype.fromDataURL = function (dataUrl) {
                    var self = this,
                        image = new Image(),
                        ratio = window.devicePixelRatio || 1,
                        width = this._canvas.width / ratio,
                        height = this._canvas.height / ratio;

                    this._reset();
                    image.src = dataUrl;
                    image.onload = function () {
                        self._ctx.drawImage(image, 0, 0, width, height);
                    };
                    this._isEmpty = false;
                };

                SignaturePad2.prototype._strokeUpdate = function (event) {
                    var point = this._createPoint(event);
                    if (this._isPointToBeUsed(point)) {
                        this._addPoint(point);
                    }
                };

                var pointsSkippedFromBeingAdded = 0;
                SignaturePad2.prototype._isPointToBeUsed = function (point) {
                    // Simplifying, De-noise
                    if (!this.minPointDistance)
                        return true;

                    var points = this.points;
                    if (points && points.length) {
                        var lastPoint = points[points.length - 1];
                        if (point.distanceTo(lastPoint) < this.minPointDistance) {
                            // log(++pointsSkippedFromBeingAdded);
                            return false;
                        }
                    }
                    return true;
                };

                SignaturePad2.prototype._strokeBegin = function (event) {
                    this._reset();
                    this._strokeUpdate(event);
                    if (typeof this.onBegin === 'function') {
                        this.onBegin(event);
                    }
                };

                SignaturePad2.prototype._strokeDraw = function (point) {
                    var ctx = this._ctx,
                        dotSize = typeof (this.dotSize) === 'function' ? this.dotSize() : this.dotSize;

                    ctx.beginPath();
                    this._drawPoint(point.x, point.y, dotSize);
                    ctx.closePath();
                    ctx.fill();
                };

                SignaturePad2.prototype._strokeEnd = function (event) {
                    var canDrawCurve = this.points.length > 2,
                        point = this.points[0];

                    if (!canDrawCurve && point) {
                        this._strokeDraw(point);
                    }
                    if (typeof this.onEnd === 'function') {
                        this.onEnd(event);
                    }
                };

                SignaturePad2.prototype._handleMouseEvents = function () {
                    this._mouseButtonDown = false;

                    this._canvas.addEventListener("mousedown", this._handleMouseDown);
                    this._canvas.addEventListener("mousemove", this._handleMouseMove);
                    document.addEventListener("mouseup", this._handleMouseUp);
                };

                SignaturePad2.prototype._handleTouchEvents = function () {
                    // Pass touch events to canvas element on mobile IE11 and Edge.
                    this._canvas.style.msTouchAction = 'none';
                    this._canvas.style.touchAction = 'none';

                    this._canvas.addEventListener("touchstart", this._handleTouchStart);
                    this._canvas.addEventListener("touchmove", this._handleTouchMove);
                    this._canvas.addEventListener("touchend", this._handleTouchEnd);
                };

                SignaturePad2.prototype.on = function () {
                    this._handleMouseEvents();
                    this._handleTouchEvents();
                };

                SignaturePad2.prototype.off = function () {
                    this._canvas.removeEventListener("mousedown", this._handleMouseDown);
                    this._canvas.removeEventListener("mousemove", this._handleMouseMove);
                    document.removeEventListener("mouseup", this._handleMouseUp);

                    this._canvas.removeEventListener("touchstart", this._handleTouchStart);
                    this._canvas.removeEventListener("touchmove", this._handleTouchMove);
                    this._canvas.removeEventListener("touchend", this._handleTouchEnd);
                };

                SignaturePad2.prototype.isEmpty = function () {
                    return this._isEmpty;
                };

                SignaturePad2.prototype._reset = function () {
                    this.points = [];
                    this._lastVelocity = 0;
                    this._lastWidth = (this.minWidth + this.maxWidth) / 2;
                    this._isEmpty = true;
                    this._ctx.fillStyle = this.penColor;
                };

                SignaturePad2.prototype._createPoint = function (event) {
                    var rect = this._canvas.getBoundingClientRect();
                    return new Point(
                        event.clientX - rect.left,
                        event.clientY - rect.top
                    );
                };

                SignaturePad2.prototype._addPoint = function (point) {
                    var points = this.points,
                        c2, c3,
                        curve, tmp;

                    points.push(point);

                    if (points.length > 2) {
                        // To reduce the initial lag make it work with 3 points
                        // by copying the first point to the beginning.
                        if (points.length === 3) points.unshift(points[0]);

                        tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
                        c2 = tmp.c2;
                        tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
                        c3 = tmp.c1;
                        curve = new Bezier(points[1], c2, c3, points[2]);
                        this._addCurve(curve);

                        // Remove the first element from the list,
                        // so that we always have no more than 4 points in points array.
                        points.shift();
                    }
                };

                SignaturePad2.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
                    var dx1 = s1.x - s2.x,
                        dy1 = s1.y - s2.y,
                        dx2 = s2.x - s3.x,
                        dy2 = s2.y - s3.y,

                        m1 = {
                            x: (s1.x + s2.x) / 2.0,
                            y: (s1.y + s2.y) / 2.0
                        },
                        m2 = {
                            x: (s2.x + s3.x) / 2.0,
                            y: (s2.y + s3.y) / 2.0
                        },

                        l1 = Math.sqrt(1.0 * dx1 * dx1 + dy1 * dy1),
                        l2 = Math.sqrt(1.0 * dx2 * dx2 + dy2 * dy2),

                        dxm = (m1.x - m2.x),
                        dym = (m1.y - m2.y),

                        k = l2 / (l1 + l2),
                        cm = {
                            x: m2.x + dxm * k,
                            y: m2.y + dym * k
                        },

                        tx = s2.x - cm.x,
                        ty = s2.y - cm.y;

                    return {
                        c1: new Point(m1.x + tx, m1.y + ty),
                        c2: new Point(m2.x + tx, m2.y + ty)
                    };
                };

                SignaturePad2.prototype._addCurve = function (curve) {
                    var startPoint = curve.startPoint,
                        endPoint = curve.endPoint,
                        velocity, newWidth;

                    velocity = endPoint.velocityFrom(startPoint);
                    velocity = this.velocityFilterWeight * velocity +
                        (1 - this.velocityFilterWeight) * this._lastVelocity;

                    newWidth = this._strokeWidth(velocity);
                    this._drawCurve(curve, this._lastWidth, newWidth);

                    this._lastVelocity = velocity;
                    this._lastWidth = newWidth;
                };

                SignaturePad2.prototype._drawPoint = function (x, y, size) {
                    var ctx = this._ctx;

                    ctx.moveTo(x, y);
                    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
                    this._isEmpty = false;
                };

                SignaturePad2.prototype._drawMark = function (x, y, size) {
                    var ctx = this._ctx;

                    ctx.save();
                    ctx.moveTo(x, y);
                    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
                    ctx.fillStyle = 'rgba(255, 0, 0, 0.2)';
                    ctx.fill();
                    ctx.restore();
                };

                SignaturePad2.prototype._drawCurve = function (curve, startWidth, endWidth) {
                    var ctx = this._ctx,
                        widthDelta = endWidth - startWidth,
                        drawSteps, width, i, t, tt, ttt, u, uu, uuu, x, y;

                    drawSteps = Math.floor(curve.length());
                    ctx.beginPath();
                    for (i = 0; i < drawSteps; i++) {
                        // Calculate the Bezier (x, y) coordinate for this step.
                        t = i / drawSteps;
                        tt = t * t;
                        ttt = tt * t;
                        u = 1 - t;
                        uu = u * u;
                        uuu = uu * u;

                        x = uuu * curve.startPoint.x;
                        x += 3 * uu * t * curve.control1.x;
                        x += 3 * u * tt * curve.control2.x;
                        x += ttt * curve.endPoint.x;

                        y = uuu * curve.startPoint.y;
                        y += 3 * uu * t * curve.control1.y;
                        y += 3 * u * tt * curve.control2.y;
                        y += ttt * curve.endPoint.y;

                        width = startWidth + ttt * widthDelta;
                        this._drawPoint(x, y, width);
                    }
                    ctx.closePath();
                    ctx.fill();
                };

                SignaturePad2.prototype._strokeWidth = function (velocity) {
                    return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
                };

                var Point = function (x, y, time) {
                    this.x = x;
                    this.y = y;
                    this.time = time || new Date().getTime();
                };

                Point.prototype.velocityFrom = function (start) {
                    return (this.time !== start.time) ? this.distanceTo(start) / (this.time - start.time) : 1;
                };

                Point.prototype.distanceTo = function (start) {
                    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
                };

                var Bezier = function (startPoint, control1, control2, endPoint) {
                    this.startPoint = startPoint;
                    this.control1 = control1;
                    this.control2 = control2;
                    this.endPoint = endPoint;
                };

                // Returns approximated length.
                Bezier.prototype.length = function () {
                    var steps = 10,
                        length = 0,
                        i, t, cx, cy, px, py, xdiff, ydiff;

                    for (i = 0; i <= steps; i++) {
                        t = i / steps;
                        cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
                        cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
                        if (i > 0) {
                            xdiff = cx - px;
                            ydiff = cy - py;
                            length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                        }
                        px = cx;
                        py = cy;
                    }
                    return length;
                };

                Bezier.prototype._point = function (t, start, c1, c2, end) {
                    return start * (1.0 - t) * (1.0 - t) * (1.0 - t) +
                        3.0 * c1 * (1.0 - t) * (1.0 - t) * t +
                        3.0 * c2 * (1.0 - t) * t * t +
                        end * t * t * t;
                };

                return SignaturePad2;
            })(document);

            var signaturePad2 = new SignaturePad2(document.getElementById('signature-pad2'), {
                backgroundColor: 'rgba(255, 255, 255, 0)',
                penColor: 'rgb(0, 0, 0)',
                velocityFilterWeight: .7,
                minWidth: 0.5,
                maxWidth: 2.5,
                throttle: 16, // max x milli seconds on event update, OBS! this introduces lag for event update
                minPointDistance: 3,
            });

            var saveButton2 = document.getElementById('save2'),
                clearButton2 = document.getElementById('clear2'),
                editButton2 = document.getElementById('edit2'),
                showPointsToggle = document.getElementById('showPointsToggle');

            saveButton2.addEventListener('click', function (event) {
                var data = signaturePad2.toDataURL('image/png');
                RentalsCaptureCtrl.secondPersonSignature = {
                    FileName: "Signature",
                    Blob: signaturePad.getByteArrayData(data)
                };

                $("#save2").hide();
                $("#signature-pad2").hide();
                $("#signature-pad-empty2").show();
                $("#clear2").show();
                $("#edit2").show();

                const ctx = document.getElementById("signature-pad-empty2").getContext("2d");
                ctx.font = "20px Italic Montserrat";
                ctx.fillStyle = "Grey";
                ctx.fillText("Signature Saved", 20, 55);
            });

            if (clearButton2) {
                clearButton2.addEventListener('click', function (event) {
                    signaturePad2.clear();
                    RentalsCaptureCtrl.secondPersonSignature = {
                        FileName: null,
                        Blob: null
                    };

                    $("#save2").show();
                    $("#clear2").hide();
                    $("#edit2").hide();
                    $("#signature-pad2").show();
                    $("#signature-pad-empty2").hide();
                });
            }

            if (editButton2) {
                editButton2.addEventListener('click', function (event) {
                    $("#save2").show();
                    $("#edit2").hide();
                    $("#clear2").hide();
                    $("#signature-pad2").show();
                    $("#signature-pad-empty2").hide();
                });
            }

            if (showPointsToggle) {
                showPointsToggle.addEventListener('click', function (event) {
                    signaturePad.showPointsToggle();
                    showPointsToggle.classList.toggle('toggle');
                });
            }

            //section 3
            var SignaturePad3 = (function (document) {
                "use strict";

                var log = console.log.bind(console);

                var SignaturePad3 = function (canvas, options) {
                    var self = this,
                        opts = options || {};

                    this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
                    this.minWidth = opts.minWidth || 0.5;
                    this.maxWidth = opts.maxWidth || 2.5;
                    this.dotSize = opts.dotSize || function () {
                        return (self.minWidth + self.maxWidth) / 2;
                    };
                    this.penColor = opts.penColor || "black";
                    this.backgroundColor = opts.backgroundColor || "rgba(0,0,0,0)";
                    this.throttle = opts.throttle || 0;
                    this.throttleOptions = {
                        leading: true,
                        trailing: true
                    };
                    this.minPointDistance = opts.minPointDistance || 0;
                    this.onEnd = opts.onEnd;
                    this.onBegin = opts.onBegin;

                    this._canvas = canvas;

                    this._ctx = canvas.getContext("2d");
                    this._ctx.lineCap = 'round';
                    this.clear();

                    // we need add these inline so they are available to unbind while still having
                    //  access to 'self' we could use _.bind but it's not worth adding a dependency
                    this._handleMouseDown = function (event) {
                        if (event.which === 1) {
                            self._mouseButtonDown = true;
                            self._strokeBegin(event);
                        }
                    };

                    var _handleMouseMove = function (event) {
                        event.preventDefault();
                        if (self._mouseButtonDown) {
                            self._strokeUpdate(event);
                            if (self.arePointsDisplayed) {
                                var point = self._createPoint(event);
                                self._drawMark(point.x, point.y, 5);
                            }
                        }
                    };

                    this._handleMouseMove = _.throttle(_handleMouseMove, self.throttle, self.throttleOptions);
                    //this._handleMouseMove = _handleMouseMove;

                    this._handleMouseUp = function (event) {
                        if (event.which === 1 && self._mouseButtonDown) {
                            self._mouseButtonDown = false;
                            self._strokeEnd(event);
                        }
                    };

                    this._handleTouchStart = function (event) {
                        if (event.targetTouches.length == 1) {
                            var touch = event.changedTouches[0];
                            self._strokeBegin(touch);
                        }
                    };

                    var _handleTouchMove = function (event) {
                        // Prevent scrolling.
                        event.preventDefault();

                        var touch = event.targetTouches[0];
                        self._strokeUpdate(touch);
                        if (self.arePointsDisplayed) {
                            var point = self._createPoint(touch);
                            self._drawMark(point.x, point.y, 5);
                        }
                    };
                    this._handleTouchMove = _.throttle(_handleTouchMove, self.throttle, self.throttleOptions);
                    //this._handleTouchMove = _handleTouchMove;

                    this._handleTouchEnd = function (event) {
                        var wasCanvasTouched = event.target === self._canvas;
                        if (wasCanvasTouched) {
                            event.preventDefault();
                            self._strokeEnd(event);
                        }
                    };

                    this._handleMouseEvents();
                    this._handleTouchEvents();
                };

                SignaturePad3.prototype.clear = function () {
                    var ctx = this._ctx,
                        canvas = this._canvas;

                    ctx.fillStyle = this.backgroundColor;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    this._reset();
                    RentalsCaptureCtrl.thirdPersonSignature = {
                        FileName: null,
                        Blob: null
                    }
                };

                SignaturePad3.prototype.showPointsToggle = function () {
                    this.arePointsDisplayed = !this.arePointsDisplayed;
                };

                SignaturePad3.prototype.toDataURL = function (imageType, quality) {
                    var canvas = this._canvas;
                    return canvas.toDataURL.apply(canvas, arguments);
                };

                SignaturePad3.prototype.getBlobData = function (dataURL) {
                    var arr = dataURL.split(','), mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);

                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }

                    return new Blob([u8arr], { type: mime });
                };

                SignaturePad3.prototype.fromDataURL = function (dataUrl) {
                    var self = this,
                        image = new Image(),
                        ratio = window.devicePixelRatio || 1,
                        width = this._canvas.width / ratio,
                        height = this._canvas.height / ratio;

                    this._reset();
                    image.src = dataUrl;
                    image.onload = function () {
                        self._ctx.drawImage(image, 0, 0, width, height);
                    };
                    this._isEmpty = false;
                };

                SignaturePad3.prototype._strokeUpdate = function (event) {
                    var point = this._createPoint(event);
                    if (this._isPointToBeUsed(point)) {
                        this._addPoint(point);
                    }
                };

                var pointsSkippedFromBeingAdded = 0;
                SignaturePad3.prototype._isPointToBeUsed = function (point) {
                    // Simplifying, De-noise
                    if (!this.minPointDistance)
                        return true;

                    var points = this.points;
                    if (points && points.length) {
                        var lastPoint = points[points.length - 1];
                        if (point.distanceTo(lastPoint) < this.minPointDistance) {
                            // log(++pointsSkippedFromBeingAdded);
                            return false;
                        }
                    }
                    return true;
                };

                SignaturePad3.prototype._strokeBegin = function (event) {
                    this._reset();
                    this._strokeUpdate(event);
                    if (typeof this.onBegin === 'function') {
                        this.onBegin(event);
                    }
                };

                SignaturePad3.prototype._strokeDraw = function (point) {
                    var ctx = this._ctx,
                        dotSize = typeof (this.dotSize) === 'function' ? this.dotSize() : this.dotSize;

                    ctx.beginPath();
                    this._drawPoint(point.x, point.y, dotSize);
                    ctx.closePath();
                    ctx.fill();
                };

                SignaturePad3.prototype._strokeEnd = function (event) {
                    var canDrawCurve = this.points.length > 2,
                        point = this.points[0];

                    if (!canDrawCurve && point) {
                        this._strokeDraw(point);
                    }
                    if (typeof this.onEnd === 'function') {
                        this.onEnd(event);
                    }
                };

                SignaturePad3.prototype._handleMouseEvents = function () {
                    this._mouseButtonDown = false;

                    this._canvas.addEventListener("mousedown", this._handleMouseDown);
                    this._canvas.addEventListener("mousemove", this._handleMouseMove);
                    document.addEventListener("mouseup", this._handleMouseUp);
                };

                SignaturePad3.prototype._handleTouchEvents = function () {
                    // Pass touch events to canvas element on mobile IE11 and Edge.
                    this._canvas.style.msTouchAction = 'none';
                    this._canvas.style.touchAction = 'none';

                    this._canvas.addEventListener("touchstart", this._handleTouchStart);
                    this._canvas.addEventListener("touchmove", this._handleTouchMove);
                    this._canvas.addEventListener("touchend", this._handleTouchEnd);
                };

                SignaturePad3.prototype.on = function () {
                    this._handleMouseEvents();
                    this._handleTouchEvents();
                };

                SignaturePad3.prototype.off = function () {
                    this._canvas.removeEventListener("mousedown", this._handleMouseDown);
                    this._canvas.removeEventListener("mousemove", this._handleMouseMove);
                    document.removeEventListener("mouseup", this._handleMouseUp);

                    this._canvas.removeEventListener("touchstart", this._handleTouchStart);
                    this._canvas.removeEventListener("touchmove", this._handleTouchMove);
                    this._canvas.removeEventListener("touchend", this._handleTouchEnd);
                };

                SignaturePad3.prototype.isEmpty = function () {
                    return this._isEmpty;
                };

                SignaturePad3.prototype._reset = function () {
                    this.points = [];
                    this._lastVelocity = 0;
                    this._lastWidth = (this.minWidth + this.maxWidth) / 2;
                    this._isEmpty = true;
                    this._ctx.fillStyle = this.penColor;
                };

                SignaturePad3.prototype._createPoint = function (event) {
                    var rect = this._canvas.getBoundingClientRect();
                    return new Point(
                        event.clientX - rect.left,
                        event.clientY - rect.top
                    );
                };

                SignaturePad3.prototype._addPoint = function (point) {
                    var points = this.points,
                        c2, c3,
                        curve, tmp;

                    points.push(point);

                    if (points.length > 2) {
                        // To reduce the initial lag make it work with 3 points
                        // by copying the first point to the beginning.
                        if (points.length === 3) points.unshift(points[0]);

                        tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
                        c2 = tmp.c2;
                        tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
                        c3 = tmp.c1;
                        curve = new Bezier(points[1], c2, c3, points[2]);
                        this._addCurve(curve);

                        // Remove the first element from the list,
                        // so that we always have no more than 4 points in points array.
                        points.shift();
                    }
                };

                SignaturePad3.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
                    var dx1 = s1.x - s2.x,
                        dy1 = s1.y - s2.y,
                        dx2 = s2.x - s3.x,
                        dy2 = s2.y - s3.y,

                        m1 = {
                            x: (s1.x + s2.x) / 2.0,
                            y: (s1.y + s2.y) / 2.0
                        },
                        m2 = {
                            x: (s2.x + s3.x) / 2.0,
                            y: (s2.y + s3.y) / 2.0
                        },

                        l1 = Math.sqrt(1.0 * dx1 * dx1 + dy1 * dy1),
                        l2 = Math.sqrt(1.0 * dx2 * dx2 + dy2 * dy2),

                        dxm = (m1.x - m2.x),
                        dym = (m1.y - m2.y),

                        k = l2 / (l1 + l2),
                        cm = {
                            x: m2.x + dxm * k,
                            y: m2.y + dym * k
                        },

                        tx = s2.x - cm.x,
                        ty = s2.y - cm.y;

                    return {
                        c1: new Point(m1.x + tx, m1.y + ty),
                        c2: new Point(m2.x + tx, m2.y + ty)
                    };
                };

                SignaturePad3.prototype._addCurve = function (curve) {
                    var startPoint = curve.startPoint,
                        endPoint = curve.endPoint,
                        velocity, newWidth;

                    velocity = endPoint.velocityFrom(startPoint);
                    velocity = this.velocityFilterWeight * velocity +
                        (1 - this.velocityFilterWeight) * this._lastVelocity;

                    newWidth = this._strokeWidth(velocity);
                    this._drawCurve(curve, this._lastWidth, newWidth);

                    this._lastVelocity = velocity;
                    this._lastWidth = newWidth;
                };

                SignaturePad3.prototype._drawPoint = function (x, y, size) {
                    var ctx = this._ctx;

                    ctx.moveTo(x, y);
                    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
                    this._isEmpty = false;
                };

                SignaturePad3.prototype._drawMark = function (x, y, size) {
                    var ctx = this._ctx;

                    ctx.save();
                    ctx.moveTo(x, y);
                    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
                    ctx.fillStyle = 'rgba(255, 0, 0, 0.2)';
                    ctx.fill();
                    ctx.restore();
                };

                SignaturePad3.prototype._drawCurve = function (curve, startWidth, endWidth) {
                    var ctx = this._ctx,
                        widthDelta = endWidth - startWidth,
                        drawSteps, width, i, t, tt, ttt, u, uu, uuu, x, y;

                    drawSteps = Math.floor(curve.length());
                    ctx.beginPath();
                    for (i = 0; i < drawSteps; i++) {
                        // Calculate the Bezier (x, y) coordinate for this step.
                        t = i / drawSteps;
                        tt = t * t;
                        ttt = tt * t;
                        u = 1 - t;
                        uu = u * u;
                        uuu = uu * u;

                        x = uuu * curve.startPoint.x;
                        x += 3 * uu * t * curve.control1.x;
                        x += 3 * u * tt * curve.control2.x;
                        x += ttt * curve.endPoint.x;

                        y = uuu * curve.startPoint.y;
                        y += 3 * uu * t * curve.control1.y;
                        y += 3 * u * tt * curve.control2.y;
                        y += ttt * curve.endPoint.y;

                        width = startWidth + ttt * widthDelta;
                        this._drawPoint(x, y, width);
                    }
                    ctx.closePath();
                    ctx.fill();
                };

                SignaturePad3.prototype._strokeWidth = function (velocity) {
                    return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
                };

                var Point = function (x, y, time) {
                    this.x = x;
                    this.y = y;
                    this.time = time || new Date().getTime();
                };

                Point.prototype.velocityFrom = function (start) {
                    return (this.time !== start.time) ? this.distanceTo(start) / (this.time - start.time) : 1;
                };

                Point.prototype.distanceTo = function (start) {
                    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
                };

                var Bezier = function (startPoint, control1, control2, endPoint) {
                    this.startPoint = startPoint;
                    this.control1 = control1;
                    this.control2 = control2;
                    this.endPoint = endPoint;
                };

                // Returns approximated length.
                Bezier.prototype.length = function () {
                    var steps = 10,
                        length = 0,
                        i, t, cx, cy, px, py, xdiff, ydiff;

                    for (i = 0; i <= steps; i++) {
                        t = i / steps;
                        cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
                        cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
                        if (i > 0) {
                            xdiff = cx - px;
                            ydiff = cy - py;
                            length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                        }
                        px = cx;
                        py = cy;
                    }
                    return length;
                };

                Bezier.prototype._point = function (t, start, c1, c2, end) {
                    return start * (1.0 - t) * (1.0 - t) * (1.0 - t) +
                        3.0 * c1 * (1.0 - t) * (1.0 - t) * t +
                        3.0 * c2 * (1.0 - t) * t * t +
                        end * t * t * t;
                };

                return SignaturePad3;
            })(document);

            var signaturePad3 = new SignaturePad3(document.getElementById('signature-pad3'), {
                backgroundColor: 'rgba(255, 255, 255, 0)',
                penColor: 'rgb(0, 0, 0)',
                velocityFilterWeight: .7,
                minWidth: 0.5,
                maxWidth: 2.5,
                throttle: 16, // max x milli seconds on event update, OBS! this introduces lag for event update
                minPointDistance: 3,
            });

            var saveButton3 = document.getElementById('save3'),
                clearButton3 = document.getElementById('clear3'),
                editButton3 = document.getElementById('edit3'),
                showPointsToggle = document.getElementById('showPointsToggle');

            saveButton3.addEventListener('click', function (event) {
                var data = signaturePad3.toDataURL('image/png');
                RentalsCaptureCtrl.thirdPersonSignature = {
                    FileName: "Signature",
                    Blob: signaturePad.getByteArrayData(data)
                };

                $("#save3").hide();
                $("#signature-pad3").hide();
                $("#signature-pad-empty3").show();
                $("#clear3").show();
                $("#edit3").show();

                const ctx = document.getElementById("signature-pad-empty3").getContext("2d");
                ctx.font = "20px Italic Montserrat";
                ctx.fillStyle = "Grey";
                ctx.fillText("Signature Saved", 20, 55);
            });

            if (clearButton3) {
                clearButton3.addEventListener('click', function (event) {
                    signaturePad3.clear();
                    RentalsCaptureCtrl.thirdPersonSignature = {
                        FileName: null,
                        Blob: null
                    };

                    $("#save3").show();
                    $("#clear3").hide();
                    $("#edit3").hide();
                    $("#signature-pad3").show();
                    $("#signature-pad-empty3").hide();
                });
            }

            if (editButton3) {
                editButton.addEventListener('click', function (event) {
                    $("#save3").show();
                    $("#edit3").hide();
                    $("#clear3").hide();
                    $("#signature-pad3").show();
                    $("#signature-pad-empty3").hide();
                });
            }

            if (showPointsToggle) {
                showPointsToggle.addEventListener('click', function (event) {
                    signaturePad.showPointsToggle();
                    showPointsToggle.classList.toggle('toggle');
                });
            }


            //section 4
            var SignaturePad4 = (function (document) {
                "use strict";

                var log = console.log.bind(console);

                var SignaturePad4 = function (canvas, options) {
                    var self = this,
                        opts = options || {};

                    this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
                    this.minWidth = opts.minWidth || 0.5;
                    this.maxWidth = opts.maxWidth || 2.5;
                    this.dotSize = opts.dotSize || function () {
                        return (self.minWidth + self.maxWidth) / 2;
                    };
                    this.penColor = opts.penColor || "black";
                    this.backgroundColor = opts.backgroundColor || "rgba(0,0,0,0)";
                    this.throttle = opts.throttle || 0;
                    this.throttleOptions = {
                        leading: true,
                        trailing: true
                    };
                    this.minPointDistance = opts.minPointDistance || 0;
                    this.onEnd = opts.onEnd;
                    this.onBegin = opts.onBegin;

                    this._canvas = canvas;

                    this._ctx = canvas.getContext("2d");
                    this._ctx.lineCap = 'round';
                    this.clear();

                    // we need add these inline so they are available to unbind while still having
                    //  access to 'self' we could use _.bind but it's not worth adding a dependency
                    this._handleMouseDown = function (event) {
                        if (event.which === 1) {
                            self._mouseButtonDown = true;
                            self._strokeBegin(event);
                        }
                    };

                    var _handleMouseMove = function (event) {
                        event.preventDefault();
                        if (self._mouseButtonDown) {
                            self._strokeUpdate(event);
                            if (self.arePointsDisplayed) {
                                var point = self._createPoint(event);
                                self._drawMark(point.x, point.y, 5);
                            }
                        }
                    };

                    this._handleMouseMove = _.throttle(_handleMouseMove, self.throttle, self.throttleOptions);
                    //this._handleMouseMove = _handleMouseMove;

                    this._handleMouseUp = function (event) {
                        if (event.which === 1 && self._mouseButtonDown) {
                            self._mouseButtonDown = false;
                            self._strokeEnd(event);
                        }
                    };

                    this._handleTouchStart = function (event) {
                        if (event.targetTouches.length == 1) {
                            var touch = event.changedTouches[0];
                            self._strokeBegin(touch);
                        }
                    };

                    var _handleTouchMove = function (event) {
                        // Prevent scrolling.
                        event.preventDefault();

                        var touch = event.targetTouches[0];
                        self._strokeUpdate(touch);
                        if (self.arePointsDisplayed) {
                            var point = self._createPoint(touch);
                            self._drawMark(point.x, point.y, 5);
                        }
                    };
                    this._handleTouchMove = _.throttle(_handleTouchMove, self.throttle, self.throttleOptions);
                    //this._handleTouchMove = _handleTouchMove;

                    this._handleTouchEnd = function (event) {
                        var wasCanvasTouched = event.target === self._canvas;
                        if (wasCanvasTouched) {
                            event.preventDefault();
                            self._strokeEnd(event);
                        }
                    };

                    this._handleMouseEvents();
                    this._handleTouchEvents();
                };

                SignaturePad4.prototype.clear = function () {
                    var ctx = this._ctx,
                        canvas = this._canvas;

                    ctx.fillStyle = this.backgroundColor;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    this._reset();
                    RentalsCaptureCtrl.fourthPersonSignature = {
                        FileName: null,
                        Blob: null
                    }
                };

                SignaturePad4.prototype.showPointsToggle = function () {
                    this.arePointsDisplayed = !this.arePointsDisplayed;
                };

                SignaturePad4.prototype.toDataURL = function (imageType, quality) {
                    var canvas = this._canvas;
                    return canvas.toDataURL.apply(canvas, arguments);
                };

                SignaturePad4.prototype.getBlobData = function (dataURL) {
                    var arr = dataURL.split(','), mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }

                    return new Blob([u8arr], { type: mime });
                };

                SignaturePad4.prototype.fromDataURL = function (dataUrl) {
                    var self = this,
                        image = new Image(),
                        ratio = window.devicePixelRatio || 1,
                        width = this._canvas.width / ratio,
                        height = this._canvas.height / ratio;

                    this._reset();
                    image.src = dataUrl;
                    image.onload = function () {
                        self._ctx.drawImage(image, 0, 0, width, height);
                    };
                    this._isEmpty = false;
                };

                SignaturePad4.prototype._strokeUpdate = function (event) {
                    var point = this._createPoint(event);
                    if (this._isPointToBeUsed(point)) {
                        this._addPoint(point);
                    }
                };

                var pointsSkippedFromBeingAdded = 0;
                SignaturePad4.prototype._isPointToBeUsed = function (point) {
                    // Simplifying, De-noise
                    if (!this.minPointDistance)
                        return true;

                    var points = this.points;
                    if (points && points.length) {
                        var lastPoint = points[points.length - 1];
                        if (point.distanceTo(lastPoint) < this.minPointDistance) {
                            // log(++pointsSkippedFromBeingAdded);
                            return false;
                        }
                    }
                    return true;
                };

                SignaturePad4.prototype._strokeBegin = function (event) {
                    this._reset();
                    this._strokeUpdate(event);
                    if (typeof this.onBegin === 'function') {
                        this.onBegin(event);
                    }
                };

                SignaturePad4.prototype._strokeDraw = function (point) {
                    var ctx = this._ctx,
                        dotSize = typeof (this.dotSize) === 'function' ? this.dotSize() : this.dotSize;

                    ctx.beginPath();
                    this._drawPoint(point.x, point.y, dotSize);
                    ctx.closePath();
                    ctx.fill();
                };

                SignaturePad4.prototype._strokeEnd = function (event) {
                    var canDrawCurve = this.points.length > 2,
                        point = this.points[0];

                    if (!canDrawCurve && point) {
                        this._strokeDraw(point);
                    }
                    if (typeof this.onEnd === 'function') {
                        this.onEnd(event);
                    }
                };

                SignaturePad4.prototype._handleMouseEvents = function () {
                    this._mouseButtonDown = false;

                    this._canvas.addEventListener("mousedown", this._handleMouseDown);
                    this._canvas.addEventListener("mousemove", this._handleMouseMove);
                    document.addEventListener("mouseup", this._handleMouseUp);
                };

                SignaturePad4.prototype._handleTouchEvents = function () {
                    // Pass touch events to canvas element on mobile IE11 and Edge.
                    this._canvas.style.msTouchAction = 'none';
                    this._canvas.style.touchAction = 'none';

                    this._canvas.addEventListener("touchstart", this._handleTouchStart);
                    this._canvas.addEventListener("touchmove", this._handleTouchMove);
                    this._canvas.addEventListener("touchend", this._handleTouchEnd);
                };

                SignaturePad4.prototype.on = function () {
                    this._handleMouseEvents();
                    this._handleTouchEvents();
                };

                SignaturePad4.prototype.off = function () {
                    this._canvas.removeEventListener("mousedown", this._handleMouseDown);
                    this._canvas.removeEventListener("mousemove", this._handleMouseMove);
                    document.removeEventListener("mouseup", this._handleMouseUp);

                    this._canvas.removeEventListener("touchstart", this._handleTouchStart);
                    this._canvas.removeEventListener("touchmove", this._handleTouchMove);
                    this._canvas.removeEventListener("touchend", this._handleTouchEnd);
                };

                SignaturePad4.prototype.isEmpty = function () {
                    return this._isEmpty;
                };

                SignaturePad4.prototype._reset = function () {
                    this.points = [];
                    this._lastVelocity = 0;
                    this._lastWidth = (this.minWidth + this.maxWidth) / 2;
                    this._isEmpty = true;
                    this._ctx.fillStyle = this.penColor;
                };

                SignaturePad4.prototype._createPoint = function (event) {
                    var rect = this._canvas.getBoundingClientRect();
                    return new Point(
                        event.clientX - rect.left,
                        event.clientY - rect.top
                    );
                };

                SignaturePad4.prototype._addPoint = function (point) {
                    var points = this.points,
                        c2, c3,
                        curve, tmp;

                    points.push(point);

                    if (points.length > 2) {
                        // To reduce the initial lag make it work with 3 points
                        // by copying the first point to the beginning.
                        if (points.length === 3) points.unshift(points[0]);

                        tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
                        c2 = tmp.c2;
                        tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
                        c3 = tmp.c1;
                        curve = new Bezier(points[1], c2, c3, points[2]);
                        this._addCurve(curve);

                        // Remove the first element from the list,
                        // so that we always have no more than 4 points in points array.
                        points.shift();
                    }
                };

                SignaturePad4.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
                    var dx1 = s1.x - s2.x,
                        dy1 = s1.y - s2.y,
                        dx2 = s2.x - s3.x,
                        dy2 = s2.y - s3.y,

                        m1 = {
                            x: (s1.x + s2.x) / 2.0,
                            y: (s1.y + s2.y) / 2.0
                        },
                        m2 = {
                            x: (s2.x + s3.x) / 2.0,
                            y: (s2.y + s3.y) / 2.0
                        },

                        l1 = Math.sqrt(1.0 * dx1 * dx1 + dy1 * dy1),
                        l2 = Math.sqrt(1.0 * dx2 * dx2 + dy2 * dy2),

                        dxm = (m1.x - m2.x),
                        dym = (m1.y - m2.y),

                        k = l2 / (l1 + l2),
                        cm = {
                            x: m2.x + dxm * k,
                            y: m2.y + dym * k
                        },

                        tx = s2.x - cm.x,
                        ty = s2.y - cm.y;

                    return {
                        c1: new Point(m1.x + tx, m1.y + ty),
                        c2: new Point(m2.x + tx, m2.y + ty)
                    };
                };

                SignaturePad4.prototype._addCurve = function (curve) {
                    var startPoint = curve.startPoint,
                        endPoint = curve.endPoint,
                        velocity, newWidth;

                    velocity = endPoint.velocityFrom(startPoint);
                    velocity = this.velocityFilterWeight * velocity +
                        (1 - this.velocityFilterWeight) * this._lastVelocity;

                    newWidth = this._strokeWidth(velocity);
                    this._drawCurve(curve, this._lastWidth, newWidth);

                    this._lastVelocity = velocity;
                    this._lastWidth = newWidth;
                };

                SignaturePad4.prototype._drawPoint = function (x, y, size) {
                    var ctx = this._ctx;

                    ctx.moveTo(x, y);
                    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
                    this._isEmpty = false;
                };

                SignaturePad4.prototype._drawMark = function (x, y, size) {
                    var ctx = this._ctx;

                    ctx.save();
                    ctx.moveTo(x, y);
                    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
                    ctx.fillStyle = 'rgba(255, 0, 0, 0.2)';
                    ctx.fill();
                    ctx.restore();
                };

                SignaturePad4.prototype._drawCurve = function (curve, startWidth, endWidth) {
                    var ctx = this._ctx,
                        widthDelta = endWidth - startWidth,
                        drawSteps, width, i, t, tt, ttt, u, uu, uuu, x, y;

                    drawSteps = Math.floor(curve.length());
                    ctx.beginPath();
                    for (i = 0; i < drawSteps; i++) {
                        // Calculate the Bezier (x, y) coordinate for this step.
                        t = i / drawSteps;
                        tt = t * t;
                        ttt = tt * t;
                        u = 1 - t;
                        uu = u * u;
                        uuu = uu * u;

                        x = uuu * curve.startPoint.x;
                        x += 3 * uu * t * curve.control1.x;
                        x += 3 * u * tt * curve.control2.x;
                        x += ttt * curve.endPoint.x;

                        y = uuu * curve.startPoint.y;
                        y += 3 * uu * t * curve.control1.y;
                        y += 3 * u * tt * curve.control2.y;
                        y += ttt * curve.endPoint.y;

                        width = startWidth + ttt * widthDelta;
                        this._drawPoint(x, y, width);
                    }
                    ctx.closePath();
                    ctx.fill();
                };

                SignaturePad4.prototype._strokeWidth = function (velocity) {
                    return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
                };

                var Point = function (x, y, time) {
                    this.x = x;
                    this.y = y;
                    this.time = time || new Date().getTime();
                };

                Point.prototype.velocityFrom = function (start) {
                    return (this.time !== start.time) ? this.distanceTo(start) / (this.time - start.time) : 1;
                };

                Point.prototype.distanceTo = function (start) {
                    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
                };

                var Bezier = function (startPoint, control1, control2, endPoint) {
                    this.startPoint = startPoint;
                    this.control1 = control1;
                    this.control2 = control2;
                    this.endPoint = endPoint;
                };

                // Returns approximated length.
                Bezier.prototype.length = function () {
                    var steps = 10,
                        length = 0,
                        i, t, cx, cy, px, py, xdiff, ydiff;

                    for (i = 0; i <= steps; i++) {
                        t = i / steps;
                        cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
                        cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
                        if (i > 0) {
                            xdiff = cx - px;
                            ydiff = cy - py;
                            length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                        }
                        px = cx;
                        py = cy;
                    }
                    return length;
                };

                Bezier.prototype._point = function (t, start, c1, c2, end) {
                    return start * (1.0 - t) * (1.0 - t) * (1.0 - t) +
                        3.0 * c1 * (1.0 - t) * (1.0 - t) * t +
                        3.0 * c2 * (1.0 - t) * t * t +
                        end * t * t * t;
                };

                return SignaturePad4;
            })(document);

            var signaturePad4 = new SignaturePad4(document.getElementById('signature-pad4'), {
                backgroundColor: 'rgba(255, 255, 255, 0)',
                penColor: 'rgb(0, 0, 0)',
                velocityFilterWeight: .7,
                minWidth: 0.5,
                maxWidth: 2.5,
                throttle: 16, // max x milli seconds on event update, OBS! this introduces lag for event update
                minPointDistance: 3,
            });

            var saveButton4 = document.getElementById('save4'),
                clearButton4 = document.getElementById('clear4'),
                editButton4 = document.getElementById('edit4'),
                showPointsToggle = document.getElementById('showPointsToggle');

            saveButton4.addEventListener('click', function (event) {
                var data = signaturePad4.toDataURL('image/png');
                RentalsCaptureCtrl.fourthPersonSignature = {
                    FileName: "Signature",
                    Blob: signaturePad.getByteArrayData(data)
                };

                $("#save4").hide();
                $("#signature-pad4").hide();
                $("#signature-pad-empty4").show();
                $("#clear4").show();
                $("#edit4").show();

                const ctx = document.getElementById("signature-pad-empty4").getContext("2d");
                ctx.font = "20px Italic Montserrat";
                ctx.fillStyle = "Grey";
                ctx.fillText("Signature Saved", 20, 55);

            });

            if (clearButton4) {
                clearButton4.addEventListener('click', function (event) {
                    signaturePad4.clear();
                    RentalsCaptureCtrl.fourthPersonSignature = {
                        FileName: null,
                        Blob: null
                    };

                    $("#save4").show();
                    $("#clear4").hide();
                    $("#edit4").hide();
                    $("#signature-pad4").show();
                    $("#signature-pad-empty4").hide();
                });
            }

            if (editButton4) {
                editButton4.addEventListener('click', function (event) {
                    $("#save4").show();
                    $("#edit4").hide();
                    $("#clear4").hide();
                    $("#signature-pad4").show();
                    $("#signature-pad-empty4").hide();
                });
            }

            if (showPointsToggle) {
                showPointsToggle.addEventListener('click', function (event) {
                    signaturePad.showPointsToggle();
                    showPointsToggle.classList.toggle('toggle');
                });
            }
        });
    }

    reload() {
        if (window.localStorage) {
            if (!localStorage.getItem('firstLoad')) {
                localStorage['firstLoad'] = true;
                window.location.reload();
            }
            else
                localStorage.removeItem('firstLoad');
        }
    }

    setRentalInitialData() {
        // RentalCompany enum: 1 = Pretor, 2 = City Living
        this.isCityLivingUnit = this.RentalInitialApplicationsIDFetched.Company === 2;
        if (this.isCityLivingUnit) {
            this.loadingSpinner = 'https://online.pretor.co.za:444/images/email/CityLivingSpinner.gif';
        }
        this.rentalsHeader.RentalInitialApplicationsID = this.RentalInitialApplicationsIDFetched.Id;
        this.rentalsHeader.rentalAmount = this.RentalInitialApplicationsIDFetched.RentalAmount;
        this.rentalsHeader.premisesAddress = this.RentalInitialApplicationsIDFetched.UnitName;
        this.rentalsHeader.RentalSingleApplicationFee = this.RentalInitialApplicationsIDFetched.RentalSingleApplicationFee;
        this.rentalsHeader.RentalJointApplicationFee = this.RentalInitialApplicationsIDFetched.RentalJointApplicationFee;
        this.firstPerson.RentalInitialApplicationsID = this.RentalInitialApplicationsIDFetched.Id;
        this.secondPerson.RentalInitialApplicationsID = this.RentalInitialApplicationsIDFetched.Id;
        this.thirdPerson.RentalInitialApplicationsID = this.RentalInitialApplicationsIDFetched.Id;
        this.fourthPerson.RentalInitialApplicationsID = this.RentalInitialApplicationsIDFetched.Id;
        this.generalDetails.RentalInitialApplicationsID = this.RentalInitialApplicationsIDFetched.Id;
        this.declarations.RentalInitialApplicationsID = this.RentalInitialApplicationsIDFetched.Id;
    }

    async getMaritalStatuses() {
        this.$timeout(async () => {
            if (!this.isBusy) {
                this._switchIsBusy(true);
            }

            await this.RentalsCaptureService.getMaritalStatuses();
            if (this.isBusy) {
                this._switchIsBusy(false);
            }
        });
    }

    handleDrop(files, type) {
        console.log('handleDrop');
        if (!this.disableFileUpload()) {
            this.uploadFile(files[0]);
        }
    }

    selectFile(id) {
        const file = $('input[type=file]#' + id)[0].files[0];
        this.uploadFile(file);
    }

    uploadFile(file) {
        if (file) {
            this.readAndStore(file);
        } else {
            console.error('No file And/Or purchaser', this.purchaser);
        }

        $('input[type=file]').each((i, el) => $(el).val(''));
    }

    readAndStore(file, type) {
        if (file.type !== 'application/pdf') {
            const errorMsg = 'Wrong file type, only PDFs are allowed.';
            this.NotificationService.error(errorMsg);

            console.error(
                `${errorMsg} "${file.name}" is not in the correct format for ${type} - only PDFs are allowed.`
            );

            return false;
        }
        else if (file.name.length > 50) {
            const errorMsg = 'Filename too long. Please shorten your filename to less than 50 characters.';
            this.NotificationService.error(errorMsg);

            console.error(
                `Filename too long. Please shorten your filename to less than 50 characters.`
            );
            return false;
        }
        else if (file.size > 5242880) {
            const errorMsg = 'File size too large. Please reduce the size of your file to smaller than 5 mega bytes.';
            this.NotificationService.error(errorMsg);

            console.error(
                `File size too large. Please reduce the size of your file to smaller than 5 mega bytes.`
            );
            return false;
        }
        else {
            return true;
        }
    }

    _updateDatePicker() {
        this.$rootScope.$eval(() => {
            this.$timeout(() => {
                const selector = '.date-picker';
                const $input = $(selector);

                $input.datepicker('update');
            });
        });
    }

    _initializeDatePicker() {
        this.$timeout(() => {
            const selector = '.date-picker';
            const $purchasorInput = $(selector, $('#purchaseInformationForm'));

            let dateNow = new Date();
            let minimumDate = moment(dateNow).startOf('month').add(2, 'M').toDate();
            if (dateNow.getDay() > 15) {
                minimumDate = moment(minimumDate).add(1, 'M').toDate();
            }

            const startDate = moment(minimumDate).toDate();
            const endDate = '+20y';

            const purchasorInputOptions = {
                startDate,
                endDate,
                autoclose: true,
                forceParse: true,
                container: selector,
                format: "yyyy-mm",
                startView: "months",
                minViewMode: "months",
                assumeNearbyYear: true,
                enableOnReadonly: true,
            };

            $purchasorInput.datepicker(purchasorInputOptions);

            const selector1 = '#date-picker-reg';
            const $regInput = $(selector1, $('#uploadRegistrationForm'));

            const regInputOptions = {
                autoclose: true,
                forceParse: true,
                container: selector1,
                format: 'yyyy-mm-dd',
                assumeNearbyYear: true,
                enableOnReadonly: true
            };

            $regInput.datepicker(regInputOptions);
        });
    }

    _switchIsBusy(flag) {
        this.$timeout(() => {
            this.isBusy = flag;
        });
    }

    checkIfOwnProperty() {
        var notOwnProperty = document.getElementById('dontOwnProperty1');
        if (notOwnProperty.checked == true) {
            $("#ifNoDiv1").show();
            this.firstPerson.OwnCurrentResidence = false;
        }
        else {
            $("#ifNoDiv1").hide();
            this.firstPerson.OwnCurrentResidence = true;
        }
    };

    checkIfOwnProperty2() {
        var notOwnProperty = document.getElementById('dontOwnProperty2');
        if (notOwnProperty.checked == true) {
            $("#ifNoDiv2").show();
            this.secondPerson.OwnCurrentResidence = false;
        }
        else {
            $("#ifNoDiv2").hide();
            this.secondPerson.OwnCurrentResidence = true;
        }
    };

    checkIfOwnProperty3() {
        var notOwnProperty = document.getElementById('dontOwnProperty3');
        if (notOwnProperty.checked == true) {
            $("#ifNoDiv3").show();
            this.thirdPerson.OwnCurrentResidence = false;
        }
        else {
            $("#ifNoDiv3").hide();
            this.thirdPerson.OwnCurrentResidence = true;
        }
    };

    checkIfOwnProperty4() {
        var notOwnProperty = document.getElementById('dontOwnProperty4');
        if (notOwnProperty.checked == true) {
            $("#ifNoDiv4").show();
            this.fourthPerson.OwnCurrentResidence = false;
        }
        else {
            $("#ifNoDiv4").hide();
            this.fourthPerson.OwnCurrentResidence = true;
        }
    };

    checkIfLivesWithPartner2() {
        var livesWithPartner = document.getElementById('livesWithPartner2');
        if (livesWithPartner.checked == true) {
            $(".secondAddress").hide();
            this.livesWithPartner2 = true;
        }
        else {
            $(".secondAddress").show();
            this.livesWithPartner2 = false;
        }
    };

    currentlyEmployedCheck2() {
        var currentlyEmployed = document.getElementById('currentlyEmployed2');
        if (currentlyEmployed.checked == false) {
            $(".employmentData2").hide();
            $("#affordability").hide();
            this.spousIsWorking2 = false;
        }
        else {
            $(".employmentData2").show();
            $("#affordability").show();
            this.spousIsWorking2 = true;
        }
    };

    checkIfLivesWithPartner3() {
        var livesWithPartner = document.getElementById('livesWithPartner3');
        if (livesWithPartner.checked == true) {
            $(".thirdAddress").hide();
            this.livesWithPartner3 = true;
        }
        else {
            $(".thirdAddress").show();
            this.livesWithPartner3 = false;
        }
    };

    currentlyEmployedCheck3() {
        var currentlyEmployed = document.getElementById('currentlyEmployed3');
        if (currentlyEmployed.checked == false) {
            $(".employmentData3").hide();
            $("#affordability2").hide();
            this.spousIsWorking3 = false;
        }
        else {
            $(".employmentData3").show();
            $("#affordability2").show();
            this.spousIsWorking3 = true;
        }
    };


    checkIfJudgementOrDefault() {
        var isDefaultOrJudgement = document.getElementById('isDefaulted');
        if (isDefaultOrJudgement.checked == true) {
            $("#isDefaultOrJudgementDiv").show();
        }
        else {
            $("#isDefaultOrJudgementDiv").hide();
        }
    }

    viewSupportingDocs() {
        var isViewingSuppDocs = document.getElementById('viewSupportingDocs');
        if (isViewingSuppDocs.checked == false) {
            $("#supportingDocs").hide();
        }
        else {
            $("#supportingDocs").show();
        }
    };

    viewOtherTenantInfo() {
        var isOccupying = document.getElementById('isOccupying');
        if (isOccupying.checked == true) {
            $("#otherTenantInformation").hide();
        }
        else {
            $("#otherTenantInformation").show();
        }
    };

    getNumberOfChildren() {
        var numOfChildren = document.getElementById('numOfChildrenInput').value;
        switch (numOfChildren) {
            case "1":
                $("#childrenAgesDiv").show();
                $("#childDiv1").show();
                $("#childDiv2").hide();
                $("#childDiv3").hide();
                $("#childDiv4").hide();
                break;
            case "2":
                $("#childrenAgesDiv").show();
                $("#childDiv1").show();
                $("#childDiv2").show();
                $("#childDiv3").hide();
                $("#childDiv4").hide();
                break;
            case "3":
                $("#childrenAgesDiv").show();
                $("#childDiv1").show();
                $("#childDiv2").show();
                $("#childDiv3").show();
                $("#childDiv4").hide();
                break;
            case "4":
                $("#childrenAgesDiv").show();
                $("#childDiv1").show();
                $("#childDiv2").show();
                $("#childDiv3").show();
                $("#childDiv4").show();
                break;
            default:
                $("#childrenAgesDiv").hide();
                $("#childDiv1").hide();
                $("#childDiv2").hide();
                $("#childDiv3").hide();
                $("#childDiv4").hide();
                break;
        }

    };

    getNumberOfVehincles() {
        var numOfVehicles = document.getElementById('numOfVehiclesInput').value;

        switch (numOfVehicles) {
            case "1":
                $("#vehicleTypeDiv1").show();
                $("#vehicleTypeDiv2").hide();
                $("#vehicleTypeDiv3").hide();
                $("#vehicleTypeDiv4").hide();
                break;
            case "2":
                $("#vehicleTypeDiv1").show();
                $("#vehicleTypeDiv2").show();
                $("#vehicleTypeDiv3").hide();
                $("#vehicleTypeDiv4").hide();
                break;
            case "3":
                $("#vehicleTypeDiv1").show();
                $("#vehicleTypeDiv2").show();
                $("#vehicleTypeDiv3").show();
                $("#vehicleTypeDiv4").hide();
                break;
            case "4":
                $("#vehicleTypeDiv1").show();
                $("#vehicleTypeDiv2").show();
                $("#vehicleTypeDiv3").show();
                $("#vehicleTypeDiv4").show();
                break;
            default:
                $("#vehicleTypeDiv1").hide();
                $("#vehicleTypeDiv2").hide();
                $("#vehicleTypeDiv3").hide();
                $("#vehicleTypeDiv4").hide();
                break;
        }
    };

    addSecondApplicantClick() {
        $("#secondApplicantInfo").show();
        $(".secondApplicantSignature").show();
        $("#secondApplicantSectionModal").show();
        $('#SecondPersonDetails').collapse('show');
        $("#addThirdApplicantDiv").show();
        $("#removeSecondApplicantDiv").show();
        $("#secondSection").show();
        this.secondApplicationChosen = true;
        $(".secondApplicantButtonDiv").hide();
    }

    uploadFirstSignature() {
        $("#save").hide();
        $("#clear").hide();
        $("#signature-pad").hide();
        $("#upload").show();
    }

    uploadSecondSignature() {
        $("#save2").hide();
        $("#clear2").hide();
        $("#signature-pad2").hide();
        $("#upload2").show();
        $("#upButton2").hide();
        $("#sigpad2").show();
    }

    uploadThirdSignature() {
        $("#save3").hide();
        $("#clear3").hide();
        $("#signature-pad3").hide();
        $("#upload3").show();
        $("#upButton3").hide();
        $("#sigpad3").show();
    }

    uploadFourthSignature() {
        $("#save4").hide();
        $("#clear4").hide();
        $("#signature-pad4").hide();
        $("#upload4").show();
        $("#upButton4").hide();
        $("#sigpad4").show();
    }

    useFirstSigPad() {
        $("#save").show();
        $("#clear").show();
        $("#signature-pad").show();
        $("#upload").hide();
        $("#upButton").show();
        $("#sigpad").hide();

    }

    useSecondSigPad() {

        $("#save2").show();
        $("#clear2").show();
        $("#signature-pad2").show();
        $("#upload2").hide();
        $("#upButton2").show();
        $("#sigpad2").hide();
    }

    useThirdSigPad() {
        $("#save3").show();
        $("#clear3").show();
        $("#signature-pad3").show();
        $("#upload3").hide();
        $("#upButton3").show();
        $("#sigpad3").hide();
    }

    useFourthSigPad() {
        $("#save4").show();
        $("#clear4").show();
        $("#signature-pad4").show();
        $("#upload4").hide();
        $("#upButton4").show();
        $("#sigpad4").hide();
    }

    removeSecondApplicantClick() {
        $("#secondApplicantInfo").hide();
        $(".secondApplicantSignature").hide();
        $("#secondApplicantSectionModal").hide();
        $("#SecondPersonDetails").collapse('hide');
        $("#addThirdApplicantDiv").hide();
        $("#removeSecondApplicantDiv").hide();
        $("#secondSection").hide();
        $(".secondApplicantButtonDiv").show();
        this.secondApplicationChosen = false;

        this.secondPerson.CurrentStreet = "";
        this.secondPerson.CurrentSuburb = "";
        this.secondPerson.CurrentCity = "";
        this.secondPerson.CurrentProvince = "";
        this.secondPerson.CurrentPostalCode = "";

        this.secondPerson.landlordName = "";
        this.secondPerson.LandlordNumber = null;
        this.secondPerson.landlordEmail = "";
        this.secondPerson.RentalAmountPaid = null;
        this.secondPerson.TimeLivingAtResidence = null;

        RentalsCaptureCtrl.secondProofOfAddressBlobData = null;

        this.secondPerson.Occupation = "";
        this.secondPerson.employersName = "";
        this.secondPerson.EmployersNumber = null;
        this.secondPerson.EmployersEmail = "";
        this.secondPerson.PeriodOfEmployment = null;
        this.secondPerson.grossMonthlySalary = null;
        this.secondPerson.currentMonthlyExpenses = null;

    }

    addThirdApplicantClick() {
        $("#removeSecondApplicantDiv").hide();

        $("#thirdApplicantInfo").show();
        $(".thirdApplicantSignature").show();
        $("#thirdApplicantSectionModal").show();
        $('#ThirdPersonDetails').collapse('show');
        $("#addFourthApplicantDiv").show();
        $("#removeThirdApplicantDiv").show();
        $("#thirdSection").show();
        this.thirdApplicationChosen = true;
        $(".thirdApplicantButtons").hide();
    }

    removeThirdApplicantClick() {
        if (!this.isFirstApplicantPartner)
            $("#removeSecondApplicantDiv").show();


        $("#thirdApplicantInfo").hide();
        $(".thirdApplicantSignature").hide();
        $("#thirdApplicantSectionModal").hide();
        $("#thirdPersonDetails").collapse('hide');
        $("#addThirdApplicantDiv").show();
        $("#removeThirdApplicantDiv").hide();
        $("#addFourthApplicantDiv").hide();
        $("#thirdSection").hide();
        this.thirdApplicationChosen = false;

    }

    addFourthApplicantClick() {

        $("#removeThirdApplicantDiv").hide();

        $("#fourthApplicantInfo").show();
        $(".fourthApplicantSignature").show();
        $("#fourthApplicantSectionModal").show();
        $('#FourthPersonDetails').collapse('show');
        $("#removeFourthApplicantDiv").show();
        $("#fourthSection").show();
        this.fourthApplicationChosen = true;
        $(".fourthApplicantButtons").hide();
    }

    removeFourthApplicantClick() {
        $("#removeThirdApplicantDiv").show();
        $("#addThirdApplicantDiv").show();

        $("#fourthApplicantInfo").hide();
        $(".fourthApplicantSignature").hide();
        $("#fourthApplicantSectionModal").hide();
        $("#fourthPersonDetails").collapse('hide');

        $("#removeFourthApplicantDiv").hide();
        $("#fourthSection").hide();
        this.fourthApplicationChosen = false;
        $(".fourthApplicantButtons").show();
    }

    checkSecondSpouse() {
        if (this.isFirstApplicantPartner == true) {
            this.secondPerson.MaritalStatus = "Married In Community Of Property";

            if (this.livesWithPartner2 == true) {
                this.secondPerson.CurrentStreet = this.firstPerson.CurrentStreet;
                this.secondPerson.CurrentSuburb = this.firstPerson.CurrentSuburb;
                this.secondPerson.CurrentCity = this.firstPerson.CurrentCity;
                this.secondPerson.CurrentProvince = this.firstPerson.CurrentProvince;
                this.secondPerson.CurrentPostalCode = this.firstPerson.CurrentPostalCode;

                this.secondPerson.landlordName = this.firstPerson.landlordName;
                this.secondPerson.LandlordNumber = this.firstPerson.LandlordNumber;
                this.secondPerson.landlordEmail = this.firstPerson.landlordEmail;
                this.secondPerson.RentalAmountPaid = this.firstPerson.RentalAmountPaid;
                this.secondPerson.TimeLivingAtResidence = this.firstPerson.TimeLivingAtResidence;

                RentalsCaptureCtrl.secondProofOfAddressBlobData = RentalsCaptureCtrl.firstProofOfAddressBlobData;
                RentalsCaptureCtrl.secondBankStatementsBlobData = RentalsCaptureCtrl.firstProofOfAddressBlobData;
            }

            if (this.spousIsWorking2 == false) {
                this.secondPerson.Occupation = "Not Working";
                this.secondPerson.employersName = "Not Working";
                this.secondPerson.EmployersNumber = "Not Working";
                this.secondPerson.EmployersEmail = "Not Working";
                this.secondPerson.employersStreet = "Not Working";
                this.secondPerson.employersSuburb = "Not Working";
                this.secondPerson.employersCity = "Not Working";
                this.secondPerson.employersProvince = "Not Working";
                this.secondPerson.employersPostalcode = "0000";
                this.secondPerson.PeriodOfEmployment = 0;
                this.secondPerson.grossMonthlySalary = 0;
                this.secondPerson.currentMonthlyExpenses = 0;
            }
        }

    }

    checkThirdSpouse() {
        if (this.isSecondApplicantPartner == true) {
            this.thirdPerson.MaritalStatus = "Married In Community Of Property";

            if (this.livesWithPartner3 == true) {
                this.thirdPerson.CurrentStreet = this.secondPerson.CurrentStreet;
                this.thirdPerson.CurrentSuburb = this.secondPerson.CurrentSuburb;
                this.thirdPerson.CurrentCity = this.secondPerson.CurrentCity;
                this.thirdPerson.CurrentProvince = this.secondPerson.CurrentProvince;
                this.thirdPerson.CurrentPostalCode = this.secondPerson.CurrentPostalCode;

                this.thirdPerson.landlordName = this.secondPerson.landlordName;
                this.thirdPerson.LandlordNumber = this.secondPerson.LandlordNumber;
                this.thirdPerson.landlordEmail = this.secondPerson.landlordEmail;
                this.thirdPerson.RentalAmountPaid = this.secondPerson.RentalAmountPaid;
                this.thirdPerson.TimeLivingAtResidence = this.secondPerson.TimeLivingAtResidence;

                RentalsCaptureCtrl.thirdProofOfAddressBlobData = RentalsCaptureCtrl.secondProofOfAddressBlobData;
            }

            if (this.spousIsWorking3 == false) {
                this.thirdPerson.Occupation = "Not Working";
                this.thirdPerson.employersName = "Not Working";
                this.thirdPerson.EmployersNumber = "Not Working";
                this.thirdPerson.EmployersEmail = "Not Working";
                this.thirdPerson.employersStreet = "Not Working";
                this.thirdPerson.employersSuburb = "Not Working";
                this.thirdPerson.employersCity = "Not Working";
                this.thirdPerson.employersProvince = "Not Working";
                this.thirdPerson.employersPostalcode = "0000";
                this.thirdPerson.PeriodOfEmployment = 0;
                this.thirdPerson.grossMonthlySalary = 0;
                this.thirdPerson.currentMonthlyExpenses = 0;
            }
        }

    }

    checkFourthSpouse() {
        if (this.isThirdApplicantPartner == true) {
            this.fourthPerson.MaritalStatus = "Married In Community Of Property";

            if (this.livesWithPartner4 == true) {
                this.fourthPerson.CurrentStreet = this.thirdPerson.CurrentStreet;
                this.fourthPerson.CurrentSuburb = this.thirdPerson.CurrentSuburb;
                this.fourthPerson.CurrentCity = this.thirdPerson.CurrentCity;
                this.fourthPerson.CurrentProvince = this.thirdPerson.CurrentProvince;
                this.fourthPerson.CurrentPostalCode = this.thirdPerson.CurrentPostalCode;

                this.fourthPerson.landlordName = this.thirdPerson.landlordName;
                this.fourthPerson.LandlordNumber = this.thirdPerson.LandlordNumber;
                this.fourthPerson.landlordEmail = this.thirdPerson.landlordEmail;
                this.fourthPerson.RentalAmountPaid = this.thirdPerson.RentalAmountPaid;
                this.fourthPerson.TimeLivingAtResidence = this.thirdPerson.TimeLivingAtResidence;

                RentalsCaptureCtrl.fourthProofOfAddressBlobData = RentalsCaptureCtrl.thirdProofOfAddressBlobData;
            }

            if (this.spousIsWorking4 == false) {
                this.fourthPerson.Occupation = "Not Working";
                this.fourthPerson.employersName = "Not Working";
                this.fourthPerson.EmployersNumber = "Not Working";
                this.fourthPerson.EmployersEmail = "Not Working";
                this.fourthPerson.employersStreet = "Not Working";
                this.fourthPerson.employersSuburb = "Not Working";
                this.fourthPerson.employersCity = "Not Working";
                this.fourthPerson.employersProvince = "Not Working";
                this.fourthPerson.employersPostalcode = "0000";
                this.fourthPerson.PeriodOfEmployment = 0;
                this.fourthPerson.grossMonthlySalary = 0;
                this.fourthPerson.currentMonthlyExpenses = 0;
            }
        }
    }

    validateAndSubmit() {
        this.checkSecondSpouse();
        this.checkThirdSpouse();
        this.checkFourthSpouse();
        this.validateForm();

        document.getElementById("acknowledgementList").innerHTML = "";
        document.getElementById("firstApplicantList").innerHTML = "";
        document.getElementById("secondApplicantList").innerHTML = "";
        document.getElementById("thirdApplicantList").innerHTML = "";
        document.getElementById("fourthApplicantList").innerHTML = "";
        document.getElementById("generalDetailsList").innerHTML = "";
        document.getElementById("declarationsList").innerHTML = "";
        if (this.formsErrors.acknowledgmentSection.length > 0) {
            var ul = document.getElementById("acknowledgementList");
            for (var x = 0; x < this.formsErrors.acknowledgmentSection.length; x++) {
                var li = document.createElement("li");
                li.appendChild(document.createTextNode(this.formsErrors.acknowledgmentSection[x]));
                ul.appendChild(li);
            }
            $("#acknowledgementSectionModal").show();
        }
        else {
            $("#acknowledgementSectionModal").hide();
        }

        if (this.formsErrors.firstApplicant.length > 0) {
            var ul = document.getElementById("firstApplicantList");
            for (var x = 0; x < this.formsErrors.firstApplicant.length; x++) {
                var li = document.createElement("li");
                li.appendChild(document.createTextNode(this.formsErrors.firstApplicant[x]));
                ul.appendChild(li);
            }
            $("#firstApplicantSectionModal").show();
        }
        else {
            $("#firstApplicantSectionModal").hide();
        }

        if (this.formsErrors.secondApplicant.length > 0) {
            var ul = document.getElementById("secondApplicantList");
            for (var x = 0; x < this.formsErrors.secondApplicant.length; x++) {
                var li = document.createElement("li");
                li.appendChild(document.createTextNode(this.formsErrors.secondApplicant[x]));
                ul.appendChild(li);
            }
            $("#secondApplicantSectionModal").show();
        }
        else {
            $("#secondApplicantSectionModal").hide();
        }

        if (this.formsErrors.thirdApplicant.length > 0) {
            var ul = document.getElementById("thirdApplicantList");
            for (var x = 0; x < this.formsErrors.thirdApplicant.length; x++) {
                var li = document.createElement("li");
                li.appendChild(document.createTextNode(this.formsErrors.thirdApplicant[x]));
                ul.appendChild(li);
            }
            $("#thirdApplicantSectionModal").show();
        }
        else {
            $("#thirdApplicantSectionModal").hide();
        }

        if (this.formsErrors.fourthApplicant.length > 0) {
            var ul = document.getElementById("fourthApplicantList");
            for (var x = 0; x < this.formsErrors.fourthApplicant.length; x++) {
                var li = document.createElement("li");
                li.appendChild(document.createTextNode(this.formsErrors.fourthApplicant[x]));
                ul.appendChild(li);
            }
            $("#fourthApplicantSectionModal").show();
        }
        else {
            $("#fourthApplicantSectionModal").hide();
        }

        if (this.formsErrors.generalSection.length > 0) {
            var ul = document.getElementById("generalDetailsList");
            for (var x = 0; x < this.formsErrors.generalSection.length; x++) {
                var li = document.createElement("li");
                li.appendChild(document.createTextNode(this.formsErrors.generalSection[x]));
                ul.appendChild(li);
            }
            $("#generalDetailsSectionModal").show();
        }
        else {
            $("#generalDetailsSectionModal").hide();
        }

        if (this.formsErrors.declarationSection.length > 0) {
            var ul = document.getElementById("declarationsList");
            for (var x = 0; x < this.formsErrors.declarationSection.length; x++) {
                var li = document.createElement("li");
                li.appendChild(document.createTextNode(this.formsErrors.declarationSection[x]));
                ul.appendChild(li);
            }
            $("#declarationsSectionModal").show();
        }
        else {
            $("#declarationsSectionModal").hide();
        }

        if (this.formsErrors.acknowledgmentSection.length > 0 ||
            this.formsErrors.firstApplicant.length > 0 ||
            this.formsErrors.secondApplicant.length > 0 ||
            this.formsErrors.thirdApplicant.length > 0 ||
            this.formsErrors.fourthApplicant.length > 0 ||
            this.formsErrors.generalSection.length > 0 ||
            this.formsErrors.declarationSection.length > 0) {
            $("#FormErrors").modal('show');

            return;
        }

        this.$timeout(async () => {
            var success = true;
            this.firstPerson.DateOfBirth = this.firstPerson.DateOfBirth.toLocaleString();
            this.rentalsHeader.OccupationDate = this.rentalsHeader.OccupationDate.toLocaleString();
            if (this.secondPerson.DateOfBirth != "")
                this.secondPerson.DateOfBirth = this.secondPerson.DateOfBirth.toLocaleString();
            if (this.thirdPerson.DateOfBirth != "")
                this.thirdPerson.DateOfBirth = this.thirdPerson.DateOfBirth.toLocaleString();
            if (this.fourthPerson.DateOfBirth != "")
                this.fourthPerson.DateOfBirth = this.fourthPerson.DateOfBirth.toLocaleString();

            try {
                $("#uploadingModal").modal('show');
                await this.RentalsCaptureService.uploadApplicationAcknowledgementInfo(this.rentalsHeader);
                await this.RentalsCaptureService.uploadApplicantInfo(this.firstPerson,
                    RentalsCaptureCtrl.firstIDBlobData,
                    RentalsCaptureCtrl.firstProofOfAddressBlobData,
                    RentalsCaptureCtrl.firstPayslipBlobData,
                    RentalsCaptureCtrl.firstBankStatementsBlobData);

                if (this.secondApplicationChosen == true) {
                    await this.RentalsCaptureService.uploadApplicantInfo(this.secondPerson,
                        RentalsCaptureCtrl.secondIDBlobData,
                        RentalsCaptureCtrl.secondProofOfAddressBlobData,
                        RentalsCaptureCtrl.secondPayslipBlobData,
                        RentalsCaptureCtrl.secondBankStatementsBlobData);
                }

                if (this.thirdApplicationChosen == true) {
                    await this.RentalsCaptureService.uploadApplicantInfo(this.thirdPerson,
                        RentalsCaptureCtrl.thirdIDBlobData,
                        RentalsCaptureCtrl.thirdProofOfAddressBlobData,
                        RentalsCaptureCtrl.thirdPayslipBlobData,
                        RentalsCaptureCtrl.thirdBankStatementsBlobData);
                }

                if (this.fourthApplicationChosen == true) {
                    await this.RentalsCaptureService.uploadApplicantInfo(this.fourthPerson,
                        RentalsCaptureCtrl.fourthIDBlobData,
                        RentalsCaptureCtrl.fourthProofOfAddressBlobData,
                        RentalsCaptureCtrl.fourthPayslipBlobData,
                        RentalsCaptureCtrl.fourthBankStatementsBlobData);
                }

                await this.RentalsCaptureService.uploadGeneralDetailsInfo(this.generalDetails,
                    RentalsCaptureCtrl.supportingDoc1,
                    RentalsCaptureCtrl.supportingDoc2,
                    RentalsCaptureCtrl.supportingDoc3);

                await this.RentalsCaptureService.uploadDeclarationsInfo(this.declarations,
                    RentalsCaptureCtrl.firstPersonSignature,
                    RentalsCaptureCtrl.secondPersonSignature,
                    RentalsCaptureCtrl.thirdPersonSignature,
                    RentalsCaptureCtrl.fourthPersonSignature);
            }
            catch (e) {
                console.log("failed to get data");
                console.log(e);
                success = false;
                $("#uploadingFailureModal").modal('show');
            }
            finally {
                $("#uploadingModal").modal('hide');
                if (success == true) {
                    $("#uploadingSuccessModal").modal('show');
                    $('#finalSubmitAndValiBtn').attr('disabled', true);
                }
            }
        });
    }

    validateForm() {
        this.formsErrors.acknowledgmentSection.length = 0;
        this.formsErrors.firstApplicant.length = 0;
        this.formsErrors.secondApplicant.length = 0;
        this.formsErrors.thirdApplicant.length = 0;
        this.formsErrors.fourthApplicant.length = 0;
        this.formsErrors.generalSection.length = 0;
        this.formsErrors.declarationSection.length = 0;

        //check initial declaration
        if (this.rentalsHeader.WhoIsApplying == "") {
            this.formsErrors.acknowledgmentSection.push("Enter Full Name in the Acknowledgment of Application section");
        }
        //if (this.rentalsHeader.rentalAmount == null) {
        //	this.formsErrors.acknowledgmentSection.push("Enter the Rentals Amount in Acknowledgment of Application section");
        //}
        if (this.rentalsHeader.leasePeriod == null) {
            this.formsErrors.acknowledgmentSection.push("Enter the Lease Period Amount in Acknowledgment of Application section");
        }
        if (this.rentalsHeader.OccupationDate == null) {
            this.formsErrors.acknowledgmentSection.push("Enter the Occupation Date in Acknowledgment of Application section");
        }

        //check first person details
        if (this.firstPerson.fullName == "" || this.firstPerson.fullName === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Full Name of the first applicant");
        }
        if (this.firstPerson.ID_Passport == "" || this.firstPerson.ID_Passport === undefined) {
            this.formsErrors.firstApplicant.push("Enter the ID Number of the first applicant");
        }
        if (this.firstPerson.Nationality == "" || this.firstPerson.Nationality === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Nationality of the first applicant");
        }
        if (this.firstPerson.DateOfBirth == "" || this.firstPerson.DateOfBirth === null) {
            this.formsErrors.firstApplicant.push("Enter the Date of Birth of the first applicant");
        }
        if (this.firstPerson.email == "" || this.firstPerson.email === undefined) {
            this.formsErrors.firstApplicant.push("Enter a Valid Email for the first applicant");
        }
        if (this.firstPerson.Telephone_Home == null || this.firstPerson.Telephone_Home === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Telephone (Work) Number of the first applicant");
        }
        else {
            if (this.firstPerson.Telephone_Home.length < 10) {
                this.formsErrors.firstApplicant.push("The Telephone (Work) Number of the first applicant is too short");
            }
        }
        if (this.firstPerson.Telephone_Cell == null || this.firstPerson.Telephone_Cell === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Cellphone Number of the first applicant");
        }
        else {
            if (this.firstPerson.Telephone_Cell.length < 10) {
                this.formsErrors.firstApplicant.push("The Cellphone Number of the first applicant is too short");
            }
        }
        if (this.firstPerson.MaritalStatus == null || this.firstPerson.MaritalStatus === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Marital Status of the first applicant");
        }
        if (this.firstPerson.nextOfKinName == "" || this.firstPerson.nextOfKinName === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Next of Kin of the first applicant");
        }
        if (this.firstPerson.nextOfKinTelephone == null || this.firstPerson.nextOfKinTelephone === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Next of Kin Telephone Number of the first applicant");
        }
        else {
            if (this.firstPerson.nextOfKinTelephone.length < 10) {
                this.formsErrors.firstApplicant.push("The Next of Kin Telephone Number of the first applicant is too short");
            }
        }
        if (this.firstPerson.CurrentStreet == "" || this.firstPerson.CurrentStreet === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Street Address of the first applicant");
        }
        if (this.firstPerson.CurrentSuburb == "" || this.firstPerson.CurrentSuburb === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Suburb Address of the first applicant");
        }
        if (this.firstPerson.CurrentCity == "" || this.firstPerson.CurrentCity === undefined) {
            this.formsErrors.firstApplicant.push("Enter the City Address of the first applicant");
        }
        if (this.firstPerson.CurrentProvince == "" || this.firstPerson.CurrentProvince === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Province Address of the first applicant");
        }
        if ($("#ID_Attachment").get(0).files.length == 0) {
            this.formsErrors.firstApplicant.push("Select the ID/Passport Attachment of the first applicant");
        }
        if ($("#ProofOfAddressAttachment").get(0).files.length == 0) {
            this.formsErrors.firstApplicant.push("Select the Proof of Address Attachment of the first applicant");
        }
        if (document.getElementById('dontOwnProperty1').checked == true) {
            if (this.firstPerson.landlordName == "" || this.firstPerson.landlordName === undefined) {
                this.formsErrors.firstApplicant.push("Enter the Land Owners Name of the first applicant");
            }
            if (this.firstPerson.LandlordNumber == null || this.firstPerson.LandlordNumber === undefined) {
                this.formsErrors.firstApplicant.push("Enter the Land Owners Telephone Number of the first applicant");
            }
            else {
                if (this.firstPerson.LandlordNumber.length < 10) {
                    this.formsErrors.firstApplicant.push("The Land Owners Number of the first applicant is too short");
                }
            }
            if (this.firstPerson.landlordEmail == "" || this.firstPerson.landlordEmail === undefined) {
                this.formsErrors.firstApplicant.push("Enter a Valid Email Address of the Land Owner for the first applicant");
            }
            if (this.firstPerson.RentalAmountPaid == null || this.firstPerson.RentalAmountPaid === undefined) {
                this.formsErrors.firstApplicant.push("Enter the Rental Amount to Landlord of the first applicant");
            }
            if (this.firstPerson.TimeLivingAtResidence == null || this.firstPerson.TimeLivingAtResidence === undefined) {
                this.formsErrors.firstApplicant.push("Enter the Amount of time living in the current residence of the first applicant");
            }
        }

        if (this.firstPerson.employersName == "" || this.firstPerson.employersName === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Employers Name of the first applicant");
        }
        if (this.firstPerson.Occupation == "" || this.firstPerson.Occupation === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Occupation of the first applicant");
        }
        if (this.firstPerson.EmployersEmail == "" || this.firstPerson.EmployersEmail === undefined) {
            this.formsErrors.firstApplicant.push("Enter a Valid Email Address for the Employer of the first applicant");
        }
        if (this.firstPerson.EmployersNumber == null || this.firstPerson.EmployersNumber === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Employer Contact Number of the first applicant");
        }
        else {
            if (this.firstPerson.EmployersNumber.length < 10) {
                this.formsErrors.firstApplicant.push("The Employer Contact Number of the first applicant is too short");
            }
        }
        if (this.firstPerson.PeriodOfEmployment == null || this.firstPerson.PeriodOfEmployment === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Period of Employment of the first applicant");
        }
        if (this.firstPerson.grossMonthlySalary == null || this.firstPerson.grossMonthlySalary === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Gross Monthly Salary of the first applicant");
        }
        if (this.firstPerson.currentMonthlyExpenses == null || this.firstPerson.currentMonthlyExpenses === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Current Monthly Expenses of the first applicant");
        }
        if (this.firstPerson.employersStreet == "" || this.firstPerson.employersStreet === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Employers Street Address of the first applicant");
        }
        if (this.firstPerson.employersSuburb == "" || this.firstPerson.employersSuburb === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Employers Suburb Address of the first applicant");
        }
        if (this.firstPerson.employersCity == "" || this.firstPerson.employersCity === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Employers City Address of the first applicant");
        }
        if (this.firstPerson.employersProvince == "" || this.firstPerson.employersProvince === undefined) {
            this.formsErrors.firstApplicant.push("Enter the Employers Province Address of the first applicant");
        }
        if ($("#payslips").get(0).files.length == 0) {
            this.formsErrors.firstApplicant.push("Select the Payslip Attachment of the first applicant");
        }
        if ($("#bankStatements").get(0).files.length == 0) {
            this.formsErrors.firstApplicant.push("Select the 3 Month Bank Statements Attachment of the first applicant");
        }
        if (RentalsCaptureCtrl.firstPersonSignature.FileName == "" || RentalsCaptureCtrl.firstPersonSignature.FileName == null) {
            this.formsErrors.firstApplicant.push("The first applicant needs to sign (Remember to click 'Save')");
        };

        //second applicant
        if (this.secondApplicationChosen == true) {
            if (this.secondPerson.fullName == "" || this.secondPerson.fullName === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Full Name of the second applicant");
            }
            if (this.secondPerson.ID_Passport == "" || this.secondPerson.ID_Passport === undefined) {
                this.formsErrors.secondApplicant.push("Enter the ID Number of the second applicant");
            }
            if (this.secondPerson.Nationality == "" || this.secondPerson.Nationality === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Nationality of the second applicant");
            }
            if (this.secondPerson.DateOfBirth == "" || this.secondPerson.DateOfBirth === null) {
                this.formsErrors.secondApplicant.push("Enter the Date of Birth of the second applicant");
            }
            if (this.secondPerson.email == "" || this.secondPerson.email === undefined) {
                this.formsErrors.secondApplicant.push("Enter a Valid Email of the second applicant");
            }
            if (this.secondPerson.Telephone_Home == null || this.secondPerson.Telephone_Home === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Telephone (Home) Number of the second applicant");
            }
            else {
                if (this.secondPerson.Telephone_Home.length < 10) {
                    this.formsErrors.secondApplicant.push("The Telephone (Home) Number of the second applicant is too short");
                }
            }
            if (this.secondPerson.Telephone_Cell == null || this.secondPerson.Telephone_Cell === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Cellphone Number of the second applicant");
            }
            else {
                if (this.secondPerson.Telephone_Cell.length < 10) {
                    this.formsErrors.secondApplicant.push("The the Cellphone Number of the second applicant is too short");
                }
            }
            if (this.secondPerson.MaritalStatus == null || this.secondPerson.MaritalStatus === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Marital Status of the second applicant");
            }
            if (this.secondPerson.nextOfKinName == "" || this.secondPerson.nextOfKinName === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Next of Kin of the second applicant");
            }
            if (this.secondPerson.nextOfKinTelephone == null || this.secondPerson.nextOfKinTelephone === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Next of Kin Telephone Number of the second applicant");
            }
            else {
                if (this.secondPerson.nextOfKinTelephone.length < 10) {
                    this.formsErrors.secondApplicant.push("The the Next of Kin Telephone Number of the second applicant is too short");
                }
            }
            if (this.secondPerson.CurrentStreet == "" || this.secondPerson.CurrentStreet === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Street Address of the second applicant");
            }
            if (this.secondPerson.CurrentSuburb == "" || this.secondPerson.CurrentSuburb === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Suburb Address of the second applicant");
            }
            if (this.secondPerson.CurrentCity == "" || this.secondPerson.CurrentCity === undefined) {
                this.formsErrors.secondApplicant.push("Enter the City Address of the second applicant");
            }
            if (this.secondPerson.CurrentProvince == "" || this.secondPerson.CurrentProvince === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Province Address of the second applicant");
            }
            if ($("#ID_Attachment2").get(0).files.length == 0) {
                this.formsErrors.secondApplicant.push("Select the ID/Passport Attachment of the second applicant");
            }
            if (this.livesWithPartner2 == false && $("#ProofOfAddressAttachment2").get(0).files.length == 0) {
                this.formsErrors.secondApplicant.push("Select the Proof of Address Attachment of the second applicant");
            }
            if (document.getElementById('dontOwnProperty2').checked == true) {
                if (this.secondPerson.landlordName == "" || this.secondPerson.landlordName === undefined) {
                    this.formsErrors.secondApplicant.push("Enter the Landlord Name of the second applicant");
                }
                if (this.secondPerson.LandlordNumber == null || this.secondPerson.LandlordNumber === undefined) {
                    this.formsErrors.secondApplicant.push("Enter the Landlord Telephone Number of the second applicant");
                }
                else {
                    if (this.secondPerson.LandlordNumber.length < 10) {
                        this.formsErrors.secondApplicant.push("The the Landlord Number of the second applicant is too short");
                    }
                }
                if (this.secondPerson.landlordEmail == "" || this.secondPerson.landlordEmail === undefined) {
                    this.formsErrors.secondApplicant.push("Enter a Valid Email Address for the Land Owner of the second applicant");
                }
                if (this.secondPerson.RentalAmountPaid == null || this.secondPerson.RentalAmountPaid === undefined) {
                    this.formsErrors.secondApplicant.push("Enter the Rental Amount to Landlord of the second applicant");
                }
                if (this.secondPerson.TimeLivingAtResidence == null || this.secondPerson.TimeLivingAtResidence === undefined) {
                    this.formsErrors.secondApplicant.push("Enter the Amount of time living in the current residence of the second applicant");
                }
            }

            if (this.secondPerson.employersName == "" || this.secondPerson.employersName === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Employers Name of the second applicant");
            }
            if (this.secondPerson.Occupation == "" || this.secondPerson.Occupation === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Occupation of the second applicant");
            }
            if (this.secondPerson.EmployersEmail == "" || this.secondPerson.EmployersEmail === undefined) {
                this.formsErrors.secondApplicant.push("Enter a Valid Email Address for the Employer of the second applicant");
            }
            if (this.secondPerson.EmployersNumber == null || this.secondPerson.EmployersNumber === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Employer Contact Number of the second applicant");
            }
            else {
                if (this.secondPerson.EmployersNumber.length < 10) {
                    this.formsErrors.secondApplicant.push("The Employer Contact Number of the second applicant is too short");
                }
            }
            if (this.secondPerson.PeriodOfEmployment == null || this.secondPerson.PeriodOfEmployment === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Period of Employment of the second applicant");
            }
            if (this.secondPerson.grossMonthlySalary == null || this.secondPerson.grossMonthlySalary === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Gross Monthly Salary of the second applicant");
            }
            if (this.secondPerson.currentMonthlyExpenses == null || this.secondPerson.currentMonthlyExpenses === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Current Monthly Expenses of the second applicant");
            }
            if (this.secondPerson.employersStreet == "" || this.secondPerson.employersStreet === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Employers Street Address of the second applicant");
            }
            if (this.secondPerson.employersSuburb == "" || this.secondPerson.employersSuburb === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Employers Suburb Address of the second applicant");
            }
            if (this.secondPerson.employersCity == "" || this.secondPerson.employersCity === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Employers City Address of the second applicant");
            }
            if (this.secondPerson.employersProvince == "" || this.secondPerson.employersProvince === undefined) {
                this.formsErrors.secondApplicant.push("Enter the Employers Province Address of the second applicant");
            }
            if (this.spousIsWorking2 == true && $("#payslips2").get(0).files.length == 0) {
                this.formsErrors.secondApplicant.push("Select the Payslip Attachment of the second applicant");
            }
            if (this.spousIsWorking2 == true && $("#bankStatements2").get(0).files.length == 0) {
                this.formsErrors.secondApplicant.push("Select the 3 Month Bank Statements Attachment of the second applicant");
            }
            if (RentalsCaptureCtrl.secondPersonSignature.FileName == "" || RentalsCaptureCtrl.secondPersonSignature.FileName == null) {
                this.formsErrors.secondApplicant.push("The second applicant needs to sign (Remember to click 'Save')");
            };
        }

        //third applicant
        if (this.thirdApplicationChosen == true) {
            if (this.thirdPerson.fullName == "" || this.thirdPerson.fullName === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Full Name of the third applicant");
            }
            if (this.thirdPerson.ID_Passport == "" || this.thirdPerson.ID_Passport === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the ID Number of the third applicant");
            }
            if (this.thirdPerson.Nationality == "" || this.thirdPerson.Nationality === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Nationality of the third applicant");
            }
            if (this.thirdPerson.DateOfBirth == "" || this.thirdPerson.DateOfBirth === null) {
                this.formsErrors.thirdApplicant.push("Enter the Date of Birth of the third applicant");
            }
            if (this.thirdPerson.email == "" || this.thirdPerson.email === undefined) {
                this.formsErrors.thirdApplicant.push("Enter a Valid Email of the third applicant");
            }
            if (this.thirdPerson.Telephone_Home == null || this.thirdPerson.Telephone_Home === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Telephone (Home) Number of the third applicant");
            }
            else {
                if (this.thirdPerson.Telephone_Home.length < 10) {
                    this.formsErrors.thirdApplicant.push("The Telephone (Home) Number of the third applicant is too short");
                }
            }
            if (this.thirdPerson.Telephone_Cell == null || this.thirdPerson.Telephone_Cell === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Cellphone Number of the third applicant");
            }
            else {
                if (this.thirdPerson.Telephone_Cell.length < 10) {
                    this.formsErrors.thirdApplicant.push("The the Cellphone Number of the third applicant is too short");
                }
            }
            if (this.thirdPerson.MaritalStatus == null || this.thirdPerson.MaritalStatus === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Marital Status of the third applicant");
            }
            if (this.thirdPerson.nextOfKinName == "" || this.thirdPerson.nextOfKinName === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Next of Kin of the third applicant");
            }
            if (this.thirdPerson.nextOfKinTelephone == null || this.thirdPerson.nextOfKinTelephone === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Next of Kin Telephone Number of the third applicant");
            }
            else {
                if (this.thirdPerson.nextOfKinTelephone.length < 10) {
                    this.formsErrors.thirdApplicant.push("The the Next of Kin Telephone Number of the third applicant is too short");
                }
            }
            if (this.thirdPerson.CurrentStreet == "" || this.thirdPerson.CurrentStreet === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Street Address of the third applicant");
            }
            if (this.thirdPerson.CurrentSuburb == "" || this.thirdPerson.CurrentSuburb === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Suburb Address of the third applicant");
            }
            if (this.thirdPerson.CurrentCity == "" || this.thirdPerson.CurrentCity === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the City Address of the third applicant");
            }
            if (this.thirdPerson.CurrentProvince == "" || this.thirdPerson.CurrentProvince === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Province Address of the third applicant");
            }
            if ($("#ID_Attachment3").get(0).files.length == 0) {
                this.formsErrors.thirdApplicant.push("Select the ID/Passport Attachment of the third applicant");
            }
            if (this.livesWithPartner3 == false && $("#ProofOfAddressAttachment3").get(0).files.length == 0) {
                this.formsErrors.thirdApplicant.push("Select the Proof of Address Attachment of the third applicant");
            }
            if (document.getElementById('dontOwnProperty3').checked == true) {
                if (this.thirdPerson.landlordName == "" || this.thirdPerson.landlordName === undefined) {
                    this.formsErrors.thirdApplicant.push("Enter the Landlord Name of the third applicant");
                }
                if (this.thirdPerson.LandlordNumber == null || this.thirdPerson.LandlordNumber === undefined) {
                    this.formsErrors.thirdApplicant.push("Enter the Landlord Telephone Number of the third applicant");
                }
                else {
                    if (this.thirdPerson.LandlordNumber.length < 10) {
                        this.formsErrors.thirdApplicant.push("The the Landlord Number of the third applicant is too short");
                    }
                }
                if (this.thirdPerson.landlordEmail == "" || this.thirdPerson.landlordEmail === undefined) {
                    this.formsErrors.thirdApplicant.push("Enter a Valid Email Address for the Land Owner of the third applicant");
                }
                if (this.thirdPerson.RentalAmountPaid == null || this.thirdPerson.RentalAmountPaid === undefined) {
                    this.formsErrors.thirdApplicant.push("Enter the Rental Amount to Landlord of the third applicant");
                }
                if (this.thirdPerson.TimeLivingAtResidence == null || this.thirdPerson.TimeLivingAtResidence === undefined) {
                    this.formsErrors.thirdApplicant.push("Enter the Amount of time living in the current residence of the third applicant");
                }
            }

            if (this.thirdPerson.employersName == "" || this.thirdPerson.employersName === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Employers Name of the third applicant");
            }
            if (this.thirdPerson.Occupation == "" || this.thirdPerson.Occupation === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Occupation of the third applicant");
            }
            if (this.thirdPerson.EmployersEmail == "" || this.thirdPerson.EmployersEmail === undefined) {
                this.formsErrors.thirdApplicant.push("Enter a Valid Email Address for the Employer of the third applicant");
            }
            if (this.thirdPerson.EmployersNumber == null || this.thirdPerson.EmployersNumber === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Employer Contact Number of the third applicant");
            }
            else {
                if (this.thirdPerson.EmployersNumber.length < 10) {
                    this.formsErrors.thirdApplicant.push("The Employer Contact Number of the third applicant is too short");
                }
            }
            if (this.thirdPerson.PeriodOfEmployment == null || this.thirdPerson.PeriodOfEmployment === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Period of Employment of the third applicant");
            }
            if (this.thirdPerson.grossMonthlySalary == null || this.thirdPerson.grossMonthlySalary === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Gross Monthly Salary of the third applicant");
            }
            if (this.thirdPerson.currentMonthlyExpenses == null || this.thirdPerson.currentMonthlyExpenses === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Current Monthly Expenses of the third applicant");
            }
            if (this.thirdPerson.employersStreet == "" || this.thirdPerson.employersStreet === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Employers Street Address of the third applicant");
            }
            if (this.thirdPerson.employersSuburb == "" || this.thirdPerson.employersSuburb === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Employers Suburb Address of the third applicant");
            }
            if (this.thirdPerson.employersCity == "" || this.thirdPerson.employersCity === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Employers City Address of the third applicant");
            }
            if (this.thirdPerson.employersProvince == "" || this.thirdPerson.employersProvince === undefined) {
                this.formsErrors.thirdApplicant.push("Enter the Employers Province Address of the third applicant");
            }
            if (this.spousIsWorking3 == true && $("#payslips3").get(0).files.length == 0) {
                this.formsErrors.thirdApplicant.push("Select the Payslip Attachment of the third applicant");
            }
            if (this.spousIsWorking3 == true && $("#bankStatements3").get(0).files.length == 0) {
                this.formsErrors.thirdApplicant.push("Select the 3 Month Bank Statements Attachment of the third applicant");
            }
            if (RentalsCaptureCtrl.thirdPersonSignature.FileName == "" || RentalsCaptureCtrl.thirdPersonSignature.FileName == null) {
                this.formsErrors.thirdApplicant.push("The third applicant needs to sign (Remember to click 'Save')");
            };
        }

        //fourth applicant 
        if (this.fourthApplicationChosen == true) {
            if (this.fourthPerson.fullName == "" || this.fourthPerson.fullName === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Full Name of the fourth applicant");
            }
            if (this.fourthPerson.ID_Passport == "" || this.fourthPerson.ID_Passport === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the ID Number of the fourth applicant");
            }
            if (this.fourthPerson.Nationality == "" || this.fourthPerson.Nationality === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Nationality of the fourth applicant");
            }
            if (this.fourthPerson.DateOfBirth == "" || this.fourthPerson.DateOfBirth === null) {
                this.formsErrors.fourthApplicant.push("Enter the Date of Birth of the fourth applicant");
            }
            if (this.fourthPerson.email == "" || this.fourthPerson.email === undefined) {
                this.formsErrors.fourthApplicant.push("Enter a Valid Email of the fourth applicant");
            }
            if (this.fourthPerson.Telephone_Home == null || this.fourthPerson.Telephone_Home === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Telephone (Home) Number of the fourth applicant");
            }
            else {
                if (this.fourthPerson.Telephone_Home.length < 10) {
                    this.formsErrors.fourthApplicant.push("The Telephone (Home) Number of the fourth applicant is too short");
                }
            }
            if (this.fourthPerson.Telephone_Cell == null || this.fourthPerson.Telephone_Cell === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Cellphone Number of the fourth applicant");
            }
            else {
                if (this.fourthPerson.Telephone_Cell.length < 10) {
                    this.formsErrors.fourthApplicant.push("The the Cellphone Number of the fourth applicant is too short");
                }
            }
            if (this.fourthPerson.MaritalStatus == null || this.fourthPerson.MaritalStatus === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Marital Status of the fourth applicant");
            }
            if (this.fourthPerson.nextOfKinName == "" || this.fourthPerson.nextOfKinName === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Next of Kin of the fourth applicant");
            }
            if (this.fourthPerson.nextOfKinTelephone == null || this.fourthPerson.nextOfKinTelephone === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Next of Kin Telephone Number of the fourth applicant");
            }
            else {
                if (this.fourthPerson.nextOfKinTelephone.length < 10) {
                    this.formsErrors.fourthApplicant.push("The the Next of Kin Telephone Number of the fourth applicant is too short");
                }
            }
            if (this.fourthPerson.CurrentStreet == "" || this.fourthPerson.CurrentStreet === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Street Address of the fourth applicant");
            }
            if (this.fourthPerson.CurrentSuburb == "" || this.fourthPerson.CurrentSuburb === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Suburb Address of the fourth applicant");
            }
            if (this.fourthPerson.CurrentCity == "" || this.fourthPerson.CurrentCity === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the City Address of the fourth applicant");
            }
            if (this.fourthPerson.CurrentProvince == "" || this.fourthPerson.CurrentProvince === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Province Address of the fourth applicant");
            }
            if ($("#ID_Attachment4").get(0).files.length == 0) {
                this.formsErrors.fourthApplicant.push("Select the ID/Passport Attachment of the fourth applicant");
            }
            if (this.livesWithPartner4 == false && $("#ProofOfAddressAttachment4").get(0).files.length == 0) {
                this.formsErrors.fourthApplicant.push("Select the Proof of Address Attachment of the fourth applicant");
            }
            if (document.getElementById('dontOwnProperty3').checked == true) {
                if (this.fourthPerson.landlordName == "" || this.fourthPerson.landlordName === undefined) {
                    this.formsErrors.fourthApplicant.push("Enter the Landlord Name of the fourth applicant");
                }
                if (this.fourthPerson.LandlordNumber == null || this.fourthPerson.LandlordNumber === undefined) {
                    this.formsErrors.fourthApplicant.push("Enter the Landlord Telephone Number of the fourth applicant");
                }
                else {
                    if (this.fourthPerson.LandlordNumber.length < 10) {
                        this.formsErrors.fourthApplicant.push("The the Landlord Number of the fourth applicant is too short");
                    }
                }
                if (this.fourthPerson.landlordEmail == "" || this.fourthPerson.landlordEmail === undefined) {
                    this.formsErrors.fourthApplicant.push("Enter a Valid Email Address for the Land Owner of the fourth applicant");
                }
                if (this.fourthPerson.RentalAmountPaid == null || this.fourthPerson.RentalAmountPaid === undefined) {
                    this.formsErrors.fourthApplicant.push("Enter the Rental Amount to Landlord of the fourth applicant");
                }
                if (this.fourthPerson.TimeLivingAtResidence == null || this.fourthPerson.TimeLivingAtResidence === undefined) {
                    this.formsErrors.fourthApplicant.push("Enter the Amount of time living in the current residence of the fourth applicant");
                }
            }

            if (this.fourthPerson.employersName == "" || this.fourthPerson.employersName === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Employers Name of the fourth applicant");
            }
            if (this.fourthPerson.Occupation == "" || this.fourthPerson.Occupation === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Occupation of the fourth applicant");
            }
            if (this.fourthPerson.EmployersEmail == "" || this.fourthPerson.EmployersEmail === undefined) {
                this.formsErrors.fourthApplicant.push("Enter a Valid Email Address for the Employer of the fourth applicant");
            }
            if (this.fourthPerson.EmployersNumber == null || this.fourthPerson.EmployersNumber === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Employer Contact Number of the fourth applicant");
            }
            else {
                if (this.fourthPerson.EmployersNumber.length < 10) {
                    this.formsErrors.fourthApplicant.push("The Employer Contact Number of the fourth applicant is too short");
                }
            }
            if (this.fourthPerson.PeriodOfEmployment == null || this.fourthPerson.PeriodOfEmployment === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Period of Employment of the fourth applicant");
            }
            if (this.fourthPerson.grossMonthlySalary == null || this.fourthPerson.grossMonthlySalary === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Gross Monthly Salary of the fourth applicant");
            }
            if (this.fourthPerson.currentMonthlyExpenses == null || this.fourthPerson.currentMonthlyExpenses === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Current Monthly Expenses of the fourth applicant");
            }
            if (this.fourthPerson.employersStreet == "" || this.fourthPerson.employersStreet === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Employers Street Address of the fourth applicant");
            }
            if (this.fourthPerson.employersSuburb == "" || this.fourthPerson.employersSuburb === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Employers Suburb Address of the fourth applicant");
            }
            if (this.fourthPerson.employersCity == "" || this.fourthPerson.employersCity === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Employers City Address of the fourth applicant");
            }
            if (this.fourthPerson.employersProvince == "" || this.fourthPerson.employersProvince === undefined) {
                this.formsErrors.fourthApplicant.push("Enter the Employers Province Address of the fourth applicant");
            }
            if (this.spousIsWorking4 == true && $("#payslips4").get(0).files.length == 0) {
                this.formsErrors.fourthApplicant.push("Select the Payslip Attachment of the fourth applicant");
            }
            if (this.spousIsWorking4 == true && $("#bankStatements4").get(0).files.length == 0) {
                this.formsErrors.fourthApplicant.push("Select the 3 Month Bank Statements Attachment of the fourth applicant");
            }
            if (RentalsCaptureCtrl.fourthPersonSignature.FileName == "" || RentalsCaptureCtrl.fourthPersonSignature.FileName == null) {
                this.formsErrors.fourthApplicant.push("The fourth applicant needs to sign (Remember to click 'Save')");
            };
        }

        //general section
        if (document.getElementById('isOccupying').checked == false && document.getElementById('isNotOccupying').checked == false) {
            this.formsErrors.generalSection.push("Please Pick if you will be occupying the property");
        }
        if (document.getElementById('isNotOccupying').checked == true) {
            if (this.generalDetails.OtherTenantFullName == null || this.generalDetails.OtherTenantFullName == "") {
                this.formsErrors.generalSection.push("Please Enter the Other Tenants Full Name");
            }
            if (this.generalDetails.OtherTenantCellNumber == null || this.generalDetails.OtherTenantCellNumber == "") {
                this.formsErrors.generalSection.push("Please Enter the Other Tenants Cellphone Number");
            }
            if (this.generalDetails.OtherTenantEmail == null || this.generalDetails.OtherTenantEmail == "") {
                this.formsErrors.generalSection.push("Please Enter the Other Tenants Email address");
            }
        }
        if (this.generalDetails.numberOfAdults == null) {
            this.formsErrors.generalSection.push("Enter the Number of Adults in the General Details");
        }
        if (this.generalDetails.numberOfChildren == null) {
            this.formsErrors.generalSection.push("Enter the Number of Children in the General Details");
        }
        if (this.generalDetails.numberOfChildren != null && this.generalDetails.numberOfChildren != 0) {
            switch (this.generalDetails.numberOfChildren) {
                case 1: if (this.generalDetails.childAge1 == null) {
                    this.formsErrors.generalSection.push("Enter the Age of the First child");
                }
                    break;
                case 2: if (this.generalDetails.childAge1 == null) {
                    this.formsErrors.generalSection.push("Enter the Age of the First child");
                }
                    if (this.generalDetails.childAge2 == null) {
                        this.formsErrors.generalSection.push("Enter the Age of the Second child");
                    }
                    break;
                case 3: if (this.generalDetails.childAge1 == null) {
                    this.formsErrors.generalSection.push("Enter the Age of the First child");
                }
                    if (this.generalDetails.childAge2 == null) {
                        this.formsErrors.generalSection.push("Enter the Age of the Second child");
                    }
                    if (this.generalDetails.childAge3 == null) {
                        this.formsErrors.generalSection.push("Enter the Age of the Third child");
                    }
                    break;
                case 4: if (this.generalDetails.childAge1 == null) {
                    this.formsErrors.generalSection.push("Enter the Age of the First child");
                }
                    if (this.generalDetails.childAge2 == null) {
                        this.formsErrors.generalSection.push("Enter the Age of the Second child");
                    }
                    if (this.generalDetails.childAge3 == null) {
                        this.formsErrors.generalSection.push("Enter the Age of the Third child");
                    }
                    if (this.generalDetails.childAge4 == null) {
                        this.formsErrors.generalSection.push("Enter the Age of the Fourth child");
                    }
                    break;
                default:
                    break;
            }
        }
        if (this.generalDetails.numberOfPets == null) {
            this.formsErrors.generalSection.push("Enter the Number of Pets in the General Details");
        }
        if (this.generalDetails.numberOfPets != null && this.generalDetails.numberOfPets > 0) {
            if (this.generalDetails.petType == "") {
                this.formsErrors.generalSection.push("Enter the Type of Pets you have");
            }
        }

        if (this.generalDetails.numberOfVehicles == null) {
            this.formsErrors.generalSection.push("Enter the number of vehicles");
        }

        if (this.generalDetails.numberOfVehicles != null && this.generalDetails.numberOfVehicles != 0) {
            switch (this.generalDetails.numberOfVehicles) {
                case 1: if (this.generalDetails.VehicleType1 == "" || this.generalDetails.VehicleType1 == undefined) {
                    this.formsErrors.generalSection.push("Enter the Type of Vehicle 1");
                }
                    if (this.generalDetails.Vehicle1Registration == "") {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 1");
                    }
                    break;

                case 2: if (this.generalDetails.VehicleType1 == "" || this.generalDetails.VehicleType1 == undefined) {
                    this.formsErrors.generalSection.push("Enter the Type of Vehicle 1");
                }
                    if (this.generalDetails.Vehicle1Registration == "" || this.generalDetails.Vehicle1Registration == undefined) {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 1");
                    }

                    if (this.generalDetails.VehicleType2 == "" || this.generalDetails.VehicleType2 == undefined) {
                        this.formsErrors.generalSection.push("Enter the Type of Vehicle 2");
                    }
                    if (this.generalDetails.Vehicle2Registration == "" || this.generalDetails.Vehicle2Registration == undefined) {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 2");
                    }
                    break;

                case 3: if (this.generalDetails.VehicleType1 == "" || this.generalDetails.VehicleType1 == undefined) {
                    this.formsErrors.generalSection.push("Enter the Type of Vehicle 1");
                }
                    if (this.generalDetails.Vehicle1Registration == "" || this.generalDetails.Vehicle1Registration == undefined) {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 1");
                    }

                    if (this.generalDetails.VehicleType2 == "" || this.generalDetails.VehicleType2 == undefined) {
                        this.formsErrors.generalSection.push("Enter the Type of Vehicle 2");
                    }
                    if (this.generalDetails.Vehicle2Registration == "" || this.generalDetails.Vehicle2Registration == undefined) {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 2");
                    }
                    if (this.generalDetails.VehicleType3 == "" || this.generalDetails.VehicleType3 == undefined) {
                        this.formsErrors.generalSection.push("Enter the Type of Vehicle 3");
                    }
                    if (this.generalDetails.Vehicle3Registration == "" || this.generalDetails.Vehicle3Registration == undefined) {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 3");
                    }
                    break;

                case 4:
                    if (this.generalDetails.VehicleType1 == "" || this.generalDetails.VehicleType1 == undefined) {
                        this.formsErrors.generalSection.push("Enter the Type of Vehicle 1");
                    }
                    if (this.generalDetails.Vehicle1Registration == "" || this.generalDetails.Vehicle1Registration == undefined) {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 1");
                    }
                    if (this.generalDetails.VehicleType2 == "" || this.generalDetails.VehicleType2 == undefined) {
                        this.formsErrors.generalSection.push("Enter the Type of Vehicle 2");
                    }
                    if (this.generalDetails.Vehicle2Registration == "" || this.generalDetails.Vehicle2Registration == undefined) {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 2");
                    }
                    if (this.generalDetails.VehicleType3 == "" || this.generalDetails.VehicleType3 == undefined) {
                        this.formsErrors.generalSection.push("Enter the Type of Vehicle 3");
                    }
                    if (this.generalDetails.Vehicle3Registration == "" || this.generalDetails.Vehicle3Registration == undefined) {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 3");
                    }
                    if (this.generalDetails.VehicleType4 == "" || this.generalDetails.VehicleType4 == undefined) {
                        this.formsErrors.generalSection.push("Enter the Type of Vehicle 4");
                    }
                    if (this.generalDetails.Vehicle4Registration == "" || this.generalDetails.Vehicle4Registration == undefined) {
                        this.formsErrors.generalSection.push("Enter the Registration number of Vehicle 4");
                    }
                    break;

                default:
                    break;
            }
        }

        if (document.getElementById('isDefaulted').checked == false && document.getElementById('isNotDefaulted').checked == false) {
            this.formsErrors.generalSection.push("Please Enter if defaults have been given to any of the applicants");
        }
        if (document.getElementById('isDefaulted').checked == true) {
            if (this.generalDetails.defaultDetails == "" || this.generalDetails.defaultDetails == undefined) {
                this.formsErrors.generalSection.push("Please Enter the details of the defaults given");
            }
        }
        if (document.getElementById('SeenProperty').checked == false && document.getElementById('NotSeenProperty').checked == false) {
            this.formsErrors.generalSection.push("Please Enter if you have seen the property");
        }

        //declarations
        if (this.declarations.WhereSigned == "" || this.generalDetails.defaultDetails == undefined) {
            this.formsErrors.declarationSection.push("Please enter the area the document was signed");
        }
        if (this.declarations.DaySigned == null || this.generalDetails.defaultDetails == undefined) {
            this.formsErrors.declarationSection.push("Please enter the day the application was signed");
        }
        if (this.declarations.MonthSigned == null || this.generalDetails.defaultDetails == undefined) {
            this.formsErrors.declarationSection.push("Please enter the month the application was signed");
        }
        if (this.declarations.YearSigned == null || this.generalDetails.defaultDetails == undefined) {
            this.formsErrors.declarationSection.push("Please enter the year the application was signed");
        }
        if (this.declarations.firstApplicant == "" || this.generalDetails.defaultDetails == undefined) {
            this.formsErrors.declarationSection.push("The First Applicants Signature is required");
        }
        if (this.secondApplicationChosen == true && this.declarations.secondApplicant == "") {
            this.formsErrors.declarationSection.push("The Second Applicants Signature is required");
        }
        if (this.thirdApplicationChosen == true && this.declarations.thirdApplicant == "") {
            this.formsErrors.declarationSection.push("The Third Applicants Signature is required");
        }
        if (this.fourthApplicationChosen == true && this.declarations.fourthApplicant == "") {
            this.formsErrors.declarationSection.push("The Fourth Applicants Signature is required");
        }
    }

    onChangeOfSubjects() {
        alert("change");
    }
}

